import * as React from 'react'
import {
  useQuery,
  useInfiniteQuery,
  useMutation,
  InfiniteData,
  useQueryClient
} from 'react-query'
import {
  GridColDef,
  GridColumnHeaderParams,
  GridRowSelectionModel
} from '@mui/x-data-grid'
import Box from '@mui/material/Box'
import {
  editAcmgClass,
  editClass,
  fetchOMIM,
  getAnalysisVariants,
  GetManyVariantIndexDto,
  getSamplesSvn,
  getVariantIndexData,
  getGlsVariantsIndex,
  getVariantsByFastTrack,
  IVariantIndexData,
  IVariantIndexResult,
  TranslateDto,
  translate,
  UpdateVariantACMGClassificationDto,
  UpdateVariantClassificationDto,
  VariantChrom,
  VariantDetailOmimData,
  fetchAnalysisVariantDetails,
  getVariantsByCNV,
  CnvVariants,
  Sample,
  AnalyzeVariantDto,
  analyzeVariant,
  GetArticlesDto,
  getArticles,
  getGoogleArticles,
  getLitvarArticles,
  getBatchArticles,
  getBatchLitvarArticles,
  fetchMitomap,
  GetMitoMapDataDto,
  IMitoMapSearchSource,
  getVariantsByCohort,
  FilterProtocol,
  getVariantsByPathway,
  getSTRData,
  getSvVariants,
  getBamUrl,
  GenePanel,
  getGenePanel,
  GetManyGeneIndexDto,
  getVariantGeneIndexData,
  fetchThalassemiaDetails,
  findHitoryByGeneAndChromNew,
  HistoryReportsResultsNew,
  getBatchCnvDecipherInfo,
  CnvDecipherInfoDto,
  fetchThalassemiaExomeDepthResult,
  GetGeneDiseaseSpecificDto,
  getGeneDiseaseSpecific,
  UpdateMultipleCnvManualDto,
  updateCnvManualData,
  getCnvManualData,
  getGlsVariants,
  getCitationsByVariation,
  putAcmgCurations,
  putGlsCuration,
  deleteGlsCuration
} from '@/@core/services/app.service'
import Tables from 'src/@core/components/tables'
import Link from 'next/link'
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import Stack from '@mui/material/Stack'
import DeleteIcon from '@mui/icons-material/Delete'
import {
  Badge,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Rating,
  TextField,
  Typography,
  Checkbox,
  CircularProgress,
  Backdrop,
  Chip,
  InputLabel,
  Select,
  Grid,
  Card,
  CardContent,
  AccordionSummaryProps,
  AccordionProps,
  Popover,
  MenuList,
  ListItemIcon,
  ListItemText,
  Autocomplete,
  ToggleButtonGroup,
  ToggleButton,
  SwipeableDrawer
} from '@mui/material'
import { useContext } from 'react'
import { AbilityContext } from '@/layouts/components/acl/Can'

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen'
import OpenInFullIcon from '@mui/icons-material/OpenInFull'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import CloseIcon from '@mui/icons-material/Close'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'

import { Variation } from '@/@core/services/app.service'
import Filter from 'mdi-material-ui/Filter'
import CircleSlice4 from 'mdi-material-ui/CircleSlice4'
import Circle from 'mdi-material-ui/Circle'
import CommentOutline from 'mdi-material-ui/CommentOutline'
import MenuDown from 'mdi-material-ui/MenuDown'
import MenuUp from 'mdi-material-ui/MenuUp'
import MenuSwap from 'mdi-material-ui/MenuSwap'
import Tree from '@/@core/components/tree'
import { useTranslation } from 'react-i18next'
import TanStackTable from '@/@core/components/tanstack-tables'
import { ColumnDef, createColumnHelper } from '@tanstack/react-table'
import {
  addCommas,
  changeV1Filter,
  changeV1Sorter,
  chromosomeRegion,
  formatVariantInheritance,
  isJson,
  isWindow,
  renameChildTypes,
  switchACMG,
  switchAnalysisType,
  unique
} from '@/@core/utils/utils'
import ACMG from './ACMG'
import { useRouter } from 'next/router'
import VariationGene from './VariationGene'
import Comments from './Comments'
import Index from './Index'

import {
  fetchVariantDetails,
  VariantDetail
} from '@/@core/services/app.service'
import ClinicalSynopsisDetail from './VariationGene/ClinicalSynopsisDetail'
import {
  ChevronDown,
  ChevronRight,
  CircleHalfFull,
  MenuClose,
  OpenInNew,
  RelationManyToMany
} from 'mdi-material-ui'
import { API, ExternalLinks } from '@/@core/services/api'
import Grading from './children/VariantDialog/Grading'
import PositionedSnackbar from '@/@core/components/message'
import IndexTabs from './Index/IndexTabs'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import {
  GroupHeader,
  GroupItems,
  NObject,
  sequenceOntology
} from '@/@core/components/filter-variants'
import { LoadingButton } from '@mui/lab'
import { Notes, PsychologyAltOutlined } from '@mui/icons-material'
import CnvHG19QcPlot from './children/quality-control-children/CnvQcPlot'
import ExportList from '@/pages/samples/SampleTabs/ExportList'
import SampleInfo from './children/VariantDialog/SampleInfo'
import SamplesTable from './children/VariantDialog/SamplesTable'
import _ from 'lodash'
import VariantsAntdTables from '@/@core/components/variants-tables-antd'
import AntdTables, { ColumnTypes } from '@/@core/components/tables-antd'
import { TableColumnsType, TableColumnType } from 'antd'
import ChinahpoSearch from '@/@core/components/chinahpo-search'
import FilterItem from '@/@core/components/tables-antd/FilterItem'
import GeneIndexTabs from './Index/GeneIndexTabs'
import FormItem from 'antd/es/form/FormItem'
import SampleGeneTable from './VariationGene/SampleGeneTable'
import { OMIM } from './OMIM'
import Columns2 from './children/table-columns/columns2'
import Columns1 from './children/table-columns/columns1'
import { AnyMxRecord, AnyNaptrRecord } from 'dns'
import Columns1CaseControl from './children/table-columns/columns1CaseControl'
import Columns1CNV from './children/table-columns/columns1CNV'
import Columns1CohortSites from './children/table-columns/columns1CohortSites'
import Columns1MT from './children/table-columns/columns1MT'
import Columns1STR from './children/table-columns/columns1STR'
import Columns1SV from './children/table-columns/columns1SV'
import Columns1Thalassemia from './children/table-columns/columns1Thalassemia'
import Columns1Total from './children/table-columns/columns1Total'
import Columns2Total from './children/table-columns/columns2Total'
import Columns2CaseControl from './children/table-columns/columns2CaseControl'
import Columns2CNV from './children/table-columns/columns2CNV'
import Columns2CohortSites from './children/table-columns/columns2CohortSites'
import Columns2MT from './children/table-columns/columns2MT'
import Columns2STR from './children/table-columns/columns2STR'
import Columns2SV from './children/table-columns/columns2SV'
import Columns2Thalassemia from './children/table-columns/columns2Thalassemia'
import CaseNumberInfo from './case-numbers-info'
import { Clingen } from './Clingen'
import Columns1ThalassemiaPlot from './children/table-columns/columns1ThalassemiaPlot'
import Columns2ThalassemiaPlot from './children/table-columns/columns2ThalassemiaPlot'

interface Props {
  setSelectRowKey?: any
  query?: {
    title?: string | undefined
    key?: string | undefined
    checked?: boolean | undefined
  }
  config?: any
  analysisInfo?: any
  refetchAnalyzeInfo?: any
  cnvSampleId?: any
  FilterSelect?: boolean
  indexChecked?: boolean
  colorToggle?: boolean
  ProbandList?: any[]
}
interface Column {
  id: string
  label: string
  minWidth?: number
  align?: 'right' | 'left' | 'center'
  format?: (value: any) => any
}

type DataIndex = keyof Variation
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  // [`& .${tooltipClasses.tooltip}`]: {
  //   backgroundColor: 'rgba(97, 97, 97)',
  //   color: 'rgb(255, 255, 255)',
  //   maxWidth: 220,
  //   fontSize: theme.typography.pxToRem(12),
  //   border: '1px solid #dadde9'
  // }
}))

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    maxHeight: 400,
    overflow: 'auto'
  }
})

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0
  },
  '&:before': {
    display: 'none'
  }
}))

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={null} {...props} />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)'
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1)
  }
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)'
}))

type Keys =
  | 'ACMG_classification'
  | 'classification'
  | 'gene'
  | 'transcript'
  | 'rs_id'
  | 'nuc_change'
  | 'gnomAD_exome_ALL'
  | 'gnomAD_exome_EAS'
  | 'CLINVAR_clnsig_final'
  | 'chrom'
  | 'coding_effect'
  | 'var_location'
  | 'f_score'
  | 'g_score'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    maxWidth: 'none'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const Badges = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: '-10px',
    backgroundColor: 'rgb(110,200,229)'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const geneName_List = [] as string[]
const RU_List = [] as string[]
const geneNameOut_List = [] as string[]

export const strRang = [
  {
    gene: 'TBP',
    max: 40,
    min: 0
  },
  {
    gene: 'PPP2R2B',
    max: 32,
    min: 0
  },
  {
    gene: 'PHOX2B',
    max: 24,
    min: 0
  },
  {
    gene: 'PABPN1',
    max: 11,
    min: 0
  },
  {
    gene: 'NOP56',
    max: 650,
    min: 0
  },
  {
    gene: 'HTT',
    max: 37,
    min: 0
  },
  {
    gene: 'FXN',
    max: 30,
    min: 0
  },
  {
    gene: 'FMR1',
    max: 45,
    min: 0
  },
  {
    gene: 'DMPK',
    max: 50,
    min: 0
  },
  {
    gene: 'CACNA1A',
    max: 20,
    min: 0
  },
  {
    gene: 'C9orf72',
    max: 23,
    min: 0
  },
  {
    gene: 'ATXN8OS',
    max: 50,
    min: 0
  },
  {
    gene: 'ATXN7',
    max: 36,
    min: 0
  },
  {
    gene: 'ATXN3',
    max: 44,
    min: 0
  },
  {
    gene: 'ATXN2',
    max: 33,
    min: 0
  },
  {
    gene: 'ATXN10',
    max: 800,
    min: 0
  },
  {
    gene: 'ATXN1',
    max: 39,
    min: 0
  },
  {
    gene: 'ATN1',
    max: 36,
    min: 0
  },
  {
    gene: 'AR',
    max: 36,
    min: 0
  }
]

const color = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgba(229,38,35,0.8)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely pathogenic',
    color: 'rgba(221,109,32,0.8)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(46, 125, 50,0.8)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240,0.4)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200,0.8)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(109,56,149,0.8)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(237, 108, 2,0.8)'
  }
]

const GLScolor = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgb(218,150,148)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely benign',
    color: 'rgb(245,182,193)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(186,204,147)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(64,113,190)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(246,209,139)'
  }
]

const ACMG_classification = [
  'Pathogenic',
  'Likely pathogenic',
  'Uncertain significance',
  'Benign',
  'Likely benign',
  'VUS'
]

const classification = [
  'pathogenic',
  'likely pathogenic',
  'drug response',
  'uncertain significance',
  'benign',
  'likely benign'
]

const CLINVAR_variant = [
  'Pathogenic',
  'Likely pathogenic',
  'Uncertain significance',
  'Benign',
  'Likely benign'
]

const TypographyA = styled(Typography)(() => ({
  fontSize: '0.8rem',
  color: 'inherit'
}))

export const ClinvarInfoTable = (params: Variation) => {
  const clinvar_info: any[] = params.clinvar_info ?? []

  const rows = clinvar_info.map((item) => {
    const obj: NObject = {}

    obj.target_end = item.target_end

    obj.target_start = item.target_start

    obj.variant_end = item.variant_end

    obj.variant_start = item.variant_start

    obj.classification = item?.data?.classification

    obj.gold_stars = item?.data?.gold_stars

    obj.allele_id = item?.data?.allele_id

    return obj
  })

  return (
    <React.Fragment>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  padding: 0
                }}
              >
                OVERLAP
              </TableCell>

              <TableCell
                sx={{
                  padding: 0
                }}
                align="right"
              >
                CLNSIG(STAR)
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.name}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 }
                }}
              >
                <TableCell
                  sx={{
                    padding: 0
                  }}
                  align="right"
                >
                  <Box sx={{ width: 100 }}>
                    <Box
                      sx={{
                        height: 20,
                        ml: `${row.variant_start * 100}px`,
                        mr: `${(1 - row.variant_end) * 100}px`,
                        bgcolor: 'red'
                      }}
                    ></Box>

                    <Box
                      sx={{
                        height: 20,
                        ml: `${row.target_start * 100}px`,
                        mr: `${(1 - row.target_end) * 100}px`,
                        bgcolor: 'blue'
                      }}
                    ></Box>
                  </Box>
                </TableCell>

                <TableCell
                  sx={{
                    padding: 0
                  }}
                  align="right"
                >
                  <Stack>
                    <Tooltip title={row.name} placement="top-start">
                      <TypographyA
                        sx={{
                          maxWidth: 100,
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          color: 'primary.main',
                          cursor: 'point'
                        }}
                        onClick={() => {
                          window.open(
                            `${ExternalLinks.ncbi.variation}/${row.allele_id}/?oq=${row.allele_id}[AlleleID]`
                          )
                        }}
                      >
                        {row.classification}
                      </TypographyA>
                    </Tooltip>

                    <Box>
                      {row.gold_stars && row.gold_stars !== '.' ? (
                        <Rating
                          readOnly
                          value={Number(row.gold_stars)}
                          max={Number(row.gold_stars)}
                        />
                      ) : (
                        ''
                      )}
                    </Box>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  )
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />
})

const VariationTables = React.forwardRef((props: Props, ref) => {
  const { t, i18n } = useTranslation()

  const router = useRouter()

  const ability = useContext(AbilityContext)

  const { id, ids, group } = router.query

  const queryClient = useQueryClient()
  const type = router.asPath.includes('/samples') ? 'sample' : 'analyze'
  const [current, setCurrent] = React.useState<Variation | null>(null)
  const [transcript_list, setTranscript_list] = React.useState<
    { gene: string; gene_name: string; transcript_id: string }[] | []
  >([])
  const commentRef = React.useRef<any>()
  const tableRef = React.useRef<any>()
  const columns2DefaultRef = React.useRef<any>()
  const columns1DefaultRef = React.useRef<any>()
  const columns2CNVRef = React.useRef<any>()
  const columns1CNVRef = React.useRef<any>()
  const columns2SVRef = React.useRef<any>()
  const columns1SVRef = React.useRef<any>()
  const columns2ThalassemiaRef = React.useRef<any>()
  const columns1ThalassemiaRef = React.useRef<any>()
  const columns2ThalassemiaPlotRef = React.useRef<any>()
  const columns1ThalassemiaPlotRef = React.useRef<any>()
  const columns2STRRef = React.useRef<any>()
  const columns1STRRef = React.useRef<any>()
  const columns2TotalRef = React.useRef<any>()
  const columns1TotalRef = React.useRef<any>()
  const columns2CaseControlRef = React.useRef<any>()
  const columns1CaseControlRef = React.useRef<any>()
  const columns2CohortSitesRef = React.useRef<any>()
  const columns1CohortSitesRef = React.useRef<any>()
  const columns2MTRef = React.useRef<any>()
  const columns1MTRef = React.useRef<any>()
  const columnHelper = createColumnHelper<Variation>()
  const [columnPlot1, setColumnPlot1] = React.useState<any[]>([])
  const [columnPlot2, setColumnPlot2] = React.useState<any[]>([])
  const [hg19jsonData, setHg19JsonData] = React.useState<any[]>([])
  const [hg38jsonData, setHg38JsonData] = React.useState<any[]>([])

  const chromosomeData = React.useMemo(() => {
    if (hg19jsonData && hg19jsonData.length) {
      return hg19jsonData
    } else if (hg38jsonData && hg38jsonData.length) {
      return hg38jsonData
    } else return []
  }, [hg19jsonData, hg38jsonData])

  const { data: genePanel } = useQuery<GenePanel[]>(
    ['genePanel'],
    async () =>
      await getGenePanel({
        pageNum: 1,
        pageSize: 1000
      }),
    {
      keepPreviousData: true
    }
  )

  const filterConfig = [
    {
      name: t('chromosome'),
      key: 'dbSNP',
      open: false,
      value: {
        chrom: [],
        posStart: '',
        posEnd: ''
      } as NObject
    },
    {
      name: t('gene'),
      key: 'gene',
      open: false,
      value: {
        genePanelSet: [],
        geneNameIn: [],
        geneNameOut: []
      } as NObject
    },
    {
      name: t('genetic-way'),
      key: 'inheritances',
      open: false,
      value: {
        inheritance: [] as string[]
      } as NObject
    },
    {
      name: t('Zygosity'),
      key: 'zygosity',
      open: false,
      value: {
        zygosity: ''
      } as NObject
    },
    {
      name: 'ROH',
      key: 'ROH',
      open: false,
      value: {
        is_ROH: []
      } as NObject
    },
    {
      name: t('phenotype'),
      key: 'phenotypes',
      open: false,
      value: {
        isUse: null,
        phenotypes: [] as string[],
        clinicalSynopsisAnd: [] as string[]
      } as NObject
    },
    {
      name: t('OMIM'),
      key: 'inheritance',
      open: false,
      value: {
        mimNumbers: [],
        inheritance: []
      } as NObject
    },
    {
      name: t('area'), // 无
      open: false,
      value: {
        geneSet: [] as string[]
      } as NObject
    },
    {
      name: t('Reads depth'),
      key: 'coverage',
      open: false,
      value: {
        readDepthOperator: 'gte',
        readDepthValue: 0,
        zygosity: '',
        qualMin: 0,
        qualMax: 0,
        alleleFrequencyOperator: 'gte',
        alleleFrequencyValue: 0
      } as NObject
    },
    {
      name: t('ACMG Score'),
      key: 'ACMG_priority',
      open: false,
      value: {
        acmgClassification: [],
        acmgScoreValue: null,
        acmgScoreOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.'
      } as NObject
    },
    {
      name: t('Index'),
      key: 'index',
      open: false,
      value: {
        ownerIndexMin: 0,
        ownerIndexMax: 0,
        indexMin: 0,
        indexMax: 0,
        organizationIndexMin: 0,
        organizationIndexMax: 0
      } as NObject
    },
    {
      name: t('Allele fraction'),
      key: 'indelOperator',
      open: false,
      value: {
        indelOperator: 'gte',
        indelValue: '',
        snvOperator: 'gte',
        snvValue: ''
      } as NObject
    },
    {
      name: t('Variation mass value'),
      key: 'qualMin',
      open: false,
      value: {
        qualMin: 0,
        qualMax: 0
      } as NObject
    },
    {
      name: t('Population frequency'),
      key: 'gnomAD_exome_ALL',
      open: false,
      value: {
        gnomAD: [],
        gnomADOperator: 'lte' as 'lte' | 'gte' | 'lte.' | 'gte.',
        gnomADValue: ''
      } as NObject
    },

    {
      name: `GLS ${t('grading')}`,
      key: 'classification',
      open: false,
      value: {
        CLINSIG_final: null
      } as NObject
    },
    {
      name: t('CLINVAR_clnsig'),
      key: 'CLINVAR_clnsig_final',
      open: false,
      value: {
        CLINVAR_clnsig_final: null
      } as NObject
    },
    {
      name: t('F Score'),
      key: 'f_score',
      open: false,
      value: {
        fscoreValue: null,
        fscoreOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.'
      } as NObject
    },
    {
      name: t('G Score'),
      key: 'g_score',
      open: false,
      value: {
        gscoreValue: null,
        gscoreOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.'
      } as NObject
    },
    {
      name: t('CN'),
      key: 'CN',
      open: false,
      value: {
        CopyNumber: null
      } as NObject
    },
    {
      name: t('In-Silico predictions'),
      key: 'SpliceAI_max_score',
      open: false,
      value: {
        insilico: [],
        CADDValue: null,
        alphaMValue: null,
        alphaMOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
        spliceAIValue: null,
        spliceAIOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
        revelValue: null,
        revelOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.'
      } as NObject
    },
    {
      name: `ACMG ${t('rating')}`,
      key: 'variantScore',
      open: false,
      value: {
        acmgClassification: [],
        acmgScoreValue: null,
        acmgScoreOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.'
      } as NObject
    },
    {
      name: t('Variant option'),
      key: 'coding_effect',
      open: false,
      value: {
        sequenceOntology: [],
        userLocusIn: [],
        userLocusOut: []
      } as NObject
    },
    {
      name: t('Variant Sources'),
      key: 'sampleSource',
      open: false,
      value: {
        sampleSource: []
      } as NObject
    },
    {
      name: `Clinvar ${t('Publication')}`,
      key: 'pubmed',
      open: false,
      value: {
        hasPubmed: []
      } as NObject
    },
    {
      name: `CNV ${t('Highlights')}`,
      key: 'scip_Highlights',
      open: false,
      value: {
        hasPositiveHighlight: false,
        hasNegativeHighlight: false
      } as NObject
    },
    {
      name: t('gnomAD SV & Clinvar SV'),
      key: 'scip_gnomAD&Clinvar',
      open: false,
      value: {
        scipOverlapRateValue: null,
        scipOverlapRateOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
        scipGnomAdOverlapRateValue: null,
        scipGnomAdOverlapRateOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
        scipClinvarOverlapRateValue: null,
        scipClinvarOverlapRateOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.'
      } as NObject
    },
    {
      name: t('Gene info'),
      key: 'scip_Geneinfo',
      open: false,
      value: {
        scipGeneOverlapRateValue: null,
        scipGeneOverlapRateOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
        scipGenePliValue: null,
        scipGenePliOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
        scipGeneLoeufValue: null,
        scipGeneLoeufOperator: 'gte' as 'lte' | 'gte' | 'lte.' | 'gte.',
        scipGeneHiIn: [],
        scipGeneTsIn: []
      } as NObject
    },
    {
      name: t('Clingen'),
      key: 'scip_Clingen',
      open: false,
      value: {
        scipClingenHaploIn: [],
        scipClingenTriploIn: []
      } as NObject
    }
  ]
  const [config, setConfig] = React.useState(filterConfig)

  const handleReset = (clearFilters: () => void) => {
    clearFilters()
  }

  const handleListChange = (
    value: any,
    name: string,
    items: { name: string },
    setSelectedKeys: any
  ) => {
    setSelectedKeys([value].flat())

    const list = config.map((item) => {
      if (item.name === items.name) {
        item.value[name] = value

        if (name === 'fscoreOperator' || name === 'gscoreOperator') {
          item.value[name] = value[0].operator
        } else if (
          (name === 'fscoreValue' || name === 'gscoreValue') &&
          value[0].value
        ) {
          item.value[name] = value[0].value
        } else if (name === 'chrom' && value[0].chrom.length) {
          item.value[name] = value[0].chrom
        } else if (name === 'posStart' && value[0].start) {
          item.value[name] = value[0].start
        } else if (name === 'CopyNumber' && value[0].CopyNumber) {
          item.value[name] = value[0].CopyNumber
        } else if (name === 'posEnd' && value[0].end) {
          item.value[name] = value[0].end
        } else if (name === 'alphaMValue' && value[0].alphaMValue) {
          item.value[name] = value[0].alphaMValue
        } else if (name === 'alphaMOperator') {
          item.value[name] = value[0].alphaMOperator
        } else if (name === 'acmgScoreValue' && value[0].acmgScoreValue) {
          item.value[name] = value[0].acmgScoreValue
        } else if (name === 'acmgScoreOperator') {
          item.value[name] = value[0].acmgScoreOperator
        } else if (name === 'acmgClassification') {
          item.value[name] = value[0].acmgClassification
        } else if (name === 'spliceAIValue' && value[0].spliceAIValue) {
          item.value[name] = value[0].spliceAIValue
        } else if (name === 'spliceAIOperator') {
          item.value[name] = value[0].spliceAIOperator
        } else if (name === 'revelValue' && value[0].revelValue) {
          item.value[name] = value[0].revelValue
        } else if (name === 'revelOperator') {
          item.value[name] = value[0].revelOperator
        } else if (name === 'zygosity') {
          item.value[name] = value[0].zygosity
        } else if (name === 'readDepthOperator') {
          item.value[name] = value[0].readDepthOperator
        } else if (name === 'readDepthValue' && value[0].readDepthValue) {
          item.value[name] = value[0].readDepthValue
        } else if (name === 'gnomADValue' && value[0].gnomADValue) {
          item.value[name] = value[0].gnomADValue
        } else if (name === 'gnomAD') {
          item.value[name] = value[0].gnomAD
        } else if (name === 'gnomADOperator') {
          item.value[name] = value[0].gnomADOperator
        } else if (name === 'mimNumbers') {
          item.value[name] = value[0].mimNumbers
        } else if (name === 'inheritance') {
          item.value[name] = value[0].inheritance
        } else if (name === 'alleleFrequencyOperator') {
          item.value[name] = value[0].alleleFrequencyOperator
        } else if (
          name === 'alleleFrequencyValue' &&
          value[0].alleleFrequencyValue
        ) {
          item.value[name] = value[0].alleleFrequencyValue
        } else if (name === 'qualMin' && value[0].qualMin) {
          item.value[name] = value[0].qualMin
        } else if (name === 'qualMax' && value[0].qualMax) {
          item.value[name] = value[0].qualMax
        } else if (name === 'ownerIndexMax' && value[0].ownerIndexMax) {
          item.value[name] = value[0].ownerIndexMax
        } else if (name === 'ownerIndexMin' && value[0].ownerIndexMin) {
          item.value[name] = value[0].ownerIndexMin
        } else if (name === 'indexMin' && value[0].indexMin) {
          item.value[name] = value[0].indexMin
        } else if (name === 'indexMax' && value[0].indexMax) {
          item.value[name] = value[0].indexMax
        } else if (
          name === 'organizationIndexMin' &&
          value[0].organizationIndexMin
        ) {
          item.value[name] = value[0].organizationIndexMin
        } else if (
          name === 'organizationIndexMax' &&
          value[0].organizationIndexMax
        ) {
          item.value[name] = value[0].organizationIndexMax
        } else if (name === 'hasPositiveHighlight') {
          console.log(
            'scip_Highlights_daa',
            value[0],
            item,
            item.value,
            item.value[name]
          )

          item.value[name] = value[0].hasPositiveHighlight
        } else if (name === 'hasNegativeHighlight') {
          console.log(
            'scip_Highlights_daa',
            value[0],
            item,
            item.value,
            item.value[name]
          )

          item.value[name] = value[0].hasNegativeHighlight
        } else if (
          name === 'scipOverlapRateValue' &&
          value[0].scipOverlapRateValue
        ) {
          item.value[name] = value[0].scipOverlapRateValue
        } else if (
          name === 'scipOverlapRateOperator' &&
          value[0].scipOverlapRateOperator
        ) {
          item.value[name] = value[0].scipOverlapRateOperator
        } else if (
          name === 'scipGnomAdOverlapRateValue' &&
          value[0].scipGnomAdOverlapRateValue
        ) {
          item.value[name] = value[0].scipGnomAdOverlapRateValue
        } else if (
          name === 'scipGnomAdOverlapRateOperator' &&
          value[0].scipGnomAdOverlapRateOperator
        ) {
          item.value[name] = value[0].scipGnomAdOverlapRateOperator
        } else if (
          name === 'scipClinvarOverlapRateValue' &&
          value[0].scipClinvarOverlapRateValue
        ) {
          item.value[name] = value[0].scipClinvarOverlapRateValue
        } else if (
          name === 'scipClinvarOverlapRateOperator' &&
          value[0].scipClinvarOverlapRateOperator
        ) {
          item.value[name] = value[0].scipClinvarOverlapRateOperator
        } else if (
          name === 'scipGeneOverlapRateValue' &&
          value[0].scipGeneOverlapRateValue
        ) {
          item.value[name] = value[0].scipGeneOverlapRateValue
        } else if (
          name === 'scipGeneOverlapRateOperator' &&
          value[0].scipGeneOverlapRateOperator
        ) {
          item.value[name] = value[0].scipGeneOverlapRateOperator
        } else if (name === 'scipGenePliValue' && value[0].scipGenePliValue) {
          item.value[name] = value[0].scipGenePliValue
        } else if (
          name === 'scipGenePliOperator' &&
          value[0].scipGenePliOperator
        ) {
          item.value[name] = value[0].scipGenePliOperator
        } else if (
          name === 'scipGeneLoeufValue' &&
          value[0].scipGeneLoeufValue
        ) {
          item.value[name] = value[0].scipGeneLoeufValue
        } else if (
          name === 'scipGeneLoeufOperator' &&
          value[0].scipGeneLoeufOperator
        ) {
          item.value[name] = value[0].scipGeneLoeufOperator
        } else if (name === 'scipGeneHiIn' && value[0].scipGeneHiIn.length) {
          item.value[name] = value[0].scipGeneHiIn
        } else if (name === 'scipGeneTsIn' && value[0].scipGeneTsIn.length) {
          item.value[name] = value[0].scipGeneTsIn
        } else if (
          name === 'scipClingenHaploIn' &&
          value[0].scipClingenHaploIn.length
        ) {
          item.value[name] = value[0].scipClingenHaploIn
        } else if (
          name === 'scipClingenTriploIn' &&
          value[0].scipClingenTriploIn.length
        ) {
          item.value[name] = value[0].scipClingenTriploIn
        }
      }

      return item
    })

    //

    setConfig(list)
  }

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): TableColumnType<Variation> => {
    const temp = config.find((i) => i.key === dataIndex)
    const temp2 = filterConfig.find((i) => i.key === dataIndex)
    let value: any[] = []
    if (JSON.stringify(temp) !== JSON.stringify(temp2) && temp2 && temp) {
      value = [temp2.value as any]
    }

    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
        close
      }) => {
        //

        return (
          <FilterItem
            dataIndex={dataIndex}
            setSelectedKeys={setSelectedKeys}
            genePanel={genePanel as any}
            handleListChange={() => {
              //
            }}
            setConfig={setConfig}
            clearFilters={clearFilters}
            confirm={confirm}
            close={close}
            handleReset={handleReset}
            analysisInfo={analysisInfo}
          />
        )
      },
      filteredValue: value
    }
  }

  const variantsColumn: (ColumnTypes[number] & {
    editable?: boolean
    dataIndex: string
  })[] = React.useMemo(() => {
    return [
      {
        title: t('Sample number'),
        dataIndex: 'sampleNumber',
        key: 'sampleNumber',
        width: 140,
        align: 'center',
        render: (value, row: any) => {
          return (
            <Tooltip title={row.historyReportsPatient.sampleId}>
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                {row.historyReportsPatient.sampleId}
              </Typography>
            </Tooltip>
          )
        }
      },
      {
        title: t('Clinical information'),
        dataIndex: 'clinicalInformation',
        key: 'clinicalInformation',
        width: 140,
        align: 'center',
        render: (value, row: any) => {
          return (
            <Tooltip
              title={
                row.historyReportsPatient &&
                row.historyReportsPatient.clinicalSymptoms
                  ? row.historyReportsPatient.clinicalSymptoms
                  : ''
              }
            >
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                {row.historyReportsPatient &&
                row.historyReportsPatient.clinicalSymptoms
                  ? row.historyReportsPatient.clinicalSymptoms
                  : ''}
              </Typography>
            </Tooltip>
          )
        }
      },
      {
        title: t('gender'),
        dataIndex: 'gender',
        key: 'gender',
        width: 80,
        align: 'center',
        render: (value, row: any) => {
          return (
            <Tooltip
              title={
                row.historyReportsPatient && row.historyReportsPatient.gender
                  ? row.historyReportsPatient.gender
                  : ''
              }
            >
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                {row.historyReportsPatient && row.historyReportsPatient.gender
                  ? t(row.historyReportsPatient.gender)
                  : ''}
              </Typography>
            </Tooltip>
          )
        }
      },
      {
        title: t('age'),
        dataIndex: 'age',
        key: 'age',
        width: 80,
        align: 'center',
        render: (value, row: any) => {
          return (
            <Tooltip
              title={
                row.historyReportsPatient && row.historyReportsPatient.age
                  ? row.historyReportsPatient.age
                  : ''
              }
            >
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                {row.historyReportsPatient && row.historyReportsPatient.age
                  ? row.historyReportsPatient.age
                  : ''}
              </Typography>
            </Tooltip>
          )
        }
      },
      {
        title: t('gene'),
        dataIndex: 'gene',
        key: 'gene',
        align: 'center',
        width: 100,
        render: (value, row: any) => {
          return (
            <Tooltip title={row.gene}>
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                {row.gene}
              </Typography>
            </Tooltip>
          )
        }
      },
      {
        title: t('Gene subregion'),
        dataIndex: 'geneSubregion',
        key: 'geneSubregion',
        align: 'center',
        width: 120,
        render: (value, row: any) => {
          return (
            <Tooltip title={row.geneSubregion}>
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                {row.geneSubregion}
              </Typography>
            </Tooltip>
          )
        }
      },
      {
        title: t('Chromosome position'),
        dataIndex: 'chromosomePosition',
        key: 'chromosomePosition',
        align: 'center',
        render: (value, row: any) => {
          return (
            <Tooltip title={row.chromosomePosition}>
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                {row.chromosomePosition}
              </Typography>
            </Tooltip>
          )
        }
      },
      {
        title: t('Transcript'),
        dataIndex: 'transcript',
        key: 'transcript',
        align: 'center',
        render: (value, row: any) => {
          return (
            <Tooltip title={row.transcript}>
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                {row.transcript}
              </Typography>
            </Tooltip>
          )
        }
      },
      {
        title: t('Nucleotide'),
        dataIndex: 'variantInfo',
        key: 'variantInfo',
        align: 'center',
        render: (value, row: any) => {
          return (
            <Tooltip title={row.variantInfo}>
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                {row.variantInfo}
              </Typography>
            </Tooltip>
          )
        }
      },
      {
        title: t('Homozygous/heterozygous'),
        dataIndex: 'genotype	',
        key: 'genotype	',
        align: 'center',
        width: 180,
        render: (value, row: any) => {
          return (
            <Tooltip title={`${row.genotype}`}>
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                {`${row.genotype}`}
              </Typography>
            </Tooltip>
          )
        }
      },
      {
        title: t('Pathogenicity analysis'),
        dataIndex: 'pathogenicityClassification',
        key: 'pathogenicityClassification',
        align: 'center',
        width: 120,
        render: (value, row: any) => {
          return (
            <Tooltip title={row.pathogenicityClassification}>
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                {row.pathogenicityClassification}
              </Typography>
            </Tooltip>
          )
        }
      },
      {
        title: t('Evidence'),
        dataIndex: 'evidenceItems',
        key: 'evidenceItems',
        align: 'center',
        render: (value, row: any) => {
          return (
            <Tooltip title={row.evidenceItems}>
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap'
                }}
              >
                {row.evidenceItems}
              </Typography>
            </Tooltip>
          )
        }
      },
      {
        title: t('Disease/Phenotype'),
        dataIndex: 'diseaseInheritance	',
        key: 'diseaseInheritance	',
        align: 'center',
        render: (value, row: any) => {
          return (
            <Tooltip title={row.diseaseInheritance}>
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                {row.diseaseInheritance}
              </Typography>
            </Tooltip>
          )
        }
      },
      {
        title: t('References'),
        dataIndex: 'references	',
        key: 'references	',
        align: 'center',
        render: (value, row: any) => {
          const References =
            row.references && isJson(row.references)
              ? JSON.parse(row.references)
              : ''

          return (
            <Tooltip title={References}>
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                {References}
              </Typography>
            </Tooltip>
          )
        }
      }
    ]
  }, [])

  const pagination = {
    pageIndex: 0,
    pageSize: 30
  }

  const [compareType, setCompareType] = React.useState<
    'f_score' | 'g_score' | 'gnomAD_exome_ALL' | 'gnomAD_exome_EAS'
  >('f_score')
  const [compare, setCompare] = React.useState<'lte' | 'gte' | 'lte.' | 'gte.'>(
    'lte'
  )
  const [compareGnomAD, setCompareGnomAD] = React.useState('0')
  const [compareValue, setCompareValue] = React.useState<number>(0)
  const [overlapRate, setOverlapRate] = React.useState<number>(0.9)
  const [filterType, setFilterType] = React.useState<string>('contain')
  const [rangResultValue, setRangResultValue] = React.useState<string>('')
  const [filter, setFilter] = React.useState<string>('')
  const [thalassemiaPlot, setThalassemiaPlot] = React.useState<string>('')
  const [open, setOpen] = React.useState(false)
  const [data, setData] = React.useState<any[]>([])
  const [CnvManual, setCnvManual] = React.useState<Array<any>>([])
  const [filterGeneData, setFilterGeneData] = React.useState<any[]>([])
  const [OMIMs, setOMIM] = React.useState<VariantDetailOmimData[]>([])
  const [newOMIM, setNewOMIM] = React.useState<NObject>({})
  const [CNVs, setCNVs] = React.useState<any[]>([])
  const [DecipherInfos, setDecipherInfos] = React.useState<any[]>([])
  const [Historys, setHistorys] = React.useState<HistoryReportsResultsNew[]>([])
  const [Indexs, setIndexs] = React.useState<IVariantIndexData[]>([])
  const [GlsIndexs, setGlsIndexs] = React.useState<any[]>([])
  const [GeneIndexs, setGeneIndexs] = React.useState<any[]>([])
  const [MitoMap, setMitoMap] = React.useState<IMitoMapSearchSource[]>([])
  const [Articles, setArticles] = React.useState<any>()
  const [LitVarArticles, setLitVarArticles] = React.useState<any>()
  const [GoogleArticles, setGoogleArticle] = React.useState<any>()
  const [variantCount, setVariantCount] = React.useState<number>(0)
  const [totalCount, setTotalCount] = React.useState<number>(0)
  const [filterToggle, setFilterToggle] = React.useState(false)
  const [backop, setBackop] = React.useState(true)
  const [acmgOpen, setAcmgOpen] = React.useState(false)
  const [filterGeneOpen, setFilterGeneOpen] = React.useState(false)
  const [geneOpen, setGeneOpen] = React.useState(false)
  const [samplesOpen, setSamplesOpen] = React.useState(false)
  const messageRef = React.useRef<any>()
  const VariationGeneRef = React.useRef<any>()
  const [commentsOpen, setCommentsOpen] = React.useState(false)
  const [historyOpen, setHistoryOpen] = React.useState(false)
  const [cnvAllOpen, setCnvAllOpen] = React.useState(false)
  const [indexOpen, setIndexOpen] = React.useState(false)
  const [geneIndexOpen, setGeneIndexOpen] = React.useState(false)
  const [caseNumberInfoOpen, setCaseNumberInfoOpen] = React.useState(false)
  const [sampleInfoOpen, setSampleInfoOpen] = React.useState(false)
  const [OMIMOpen, setOMIMOpen] = React.useState(false)
  const [igvOpen, setIgvOpen] = React.useState(false)
  const [clingenOpen, setClingenOpen] = React.useState(false)
  const [cnvScipOpen, setCnvScipOpen] = React.useState(false)
  const [igvFullOpen, setIgvFullOpen] = React.useState(false)
  const [igvLocus, setIgvLocus] = React.useState('')
  const [analyzeVariants, setAnalyzeVariant] = React.useState<any>()
  const [GeneDiseaseSpecific, setGeneDiseaseSpecific] = React.useState<
    GetGeneDiseaseSpecificDto[]
  >([])
  const [isFinish, setIsFinish] = React.useState<boolean>(false)
  const [menuType, setMenuType] = React.useState<
    | 'list'
    | 'tree'
    | 'filter'
    | 'filter_compare'
    | 'filter_list'
    | 'filter_gnomAD_compare'
    | 'clinvar_info'
    | 'filter_gene'
    | 'IGV'
    | 'scip_gene'
    | 'scip_clingen'
  >('list')
  const [page, setPage] = React.useState(pagination)
  const [sortQuery, setSortQuery] = React.useState<any>({
    f: -1
  })
  const [filterQuery, setFilterQuery] = React.useState({})
  const [selectRowKey, setSelectRowKey] = React.useState<Array<any>>([])
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const openMenu = Boolean(anchorEl)
  const ACMGRef = React.useRef<any>()
  const GradingRef = React.useRef<any>()

  const columns2: TableColumnsType<Variation> = React.useMemo(() => {
    let column = []

    if (columns2DefaultRef.current && columns2DefaultRef.current.column) {
      column = columns2DefaultRef.current.column
    }

    if (
      props.query &&
      props.query.title &&
      (props.query.title.includes(t('CNV')) ||
        props.query.title.includes(t('Cnv')) ||
        props.query.title.includes('CNV Exon') ||
        props.query.title.includes('Sentieon CNV'))
    ) {
      if (columns2CNVRef.current && columns2CNVRef.current.column) {
        column = columns2CNVRef.current.column
      }
    }

    if (
      props.query &&
      props.query.title &&
      (props.query.title.includes(t('SV')) ||
        props.query.title.includes(t('Sv')))
    ) {
      if (columns2SVRef.current && columns2SVRef.current.column) {
        column = columns2SVRef.current.column
      }
    }

    if (
      props.query &&
      props.query.title &&
      (props.query.title === t('thalassemia') ||
        props.query.title === 'thalassemia' ||
        props.query.title === '地中海贫血')
    ) {
      if (
        columns2ThalassemiaRef.current &&
        columns2ThalassemiaRef.current.column
      ) {
        column = columns2ThalassemiaRef.current.column
      }
    }

    if (
      props.query &&
      props.query.title &&
      (props.query.title === 'thal plot' || props.query.title === '地贫 Plot')
    ) {
      if (
        columns2ThalassemiaPlotRef.current &&
        columns2ThalassemiaPlotRef.current.column
      ) {
        column = columns2ThalassemiaPlotRef.current.column
      }
    }

    if (
      props.query &&
      props.query.title &&
      props.query.title.includes(t('STR'))
    ) {
      if (columns2STRRef.current && columns2STRRef.current.column) {
        column = columns2STRRef.current.column
      }
    }

    if (
      props.query &&
      props.query.title &&
      props.query.title.includes(t('Gene'))
    ) {
      if (columns2TotalRef.current && columns2TotalRef.current.column) {
        column = columns2TotalRef.current.column
      }
    }

    if (
      props.query &&
      props.query.key &&
      props.query.key.includes('case_control')
    ) {
      if (
        columns2CaseControlRef.current &&
        columns2CaseControlRef.current.column
      ) {
        column = columns2CaseControlRef.current.column
      }
    }

    if (
      props.query &&
      props.query.key &&
      props.query.key.includes('cohort_sites')
    ) {
      if (
        columns2CohortSitesRef.current &&
        columns2CohortSitesRef.current.column
      ) {
        column = columns2CohortSitesRef.current.column
      }
    }

    if (
      props.query &&
      props.query.title &&
      (props.query?.title === t('MT') ||
        props.query?.title === 'MT' ||
        props.query?.title === '线粒体')
    ) {
      if (columns2MTRef.current && columns2MTRef.current.column) {
        column = columns2MTRef.current.column
      }
    }

    if (!props.analysisInfo.hasSCIP) {
      column = [
        ...column.filter((item: any) => !item.dataIndex?.includes('scip'))
      ]
    }

    return column
  }, [
    columns2DefaultRef,
    columns2DefaultRef.current,
    columns2SVRef,
    columns2SVRef.current,
    columns2ThalassemiaRef,
    columns2ThalassemiaRef.current,
    columns2ThalassemiaPlotRef,
    columns2ThalassemiaPlotRef.current,
    columns2STRRef,
    columns2STRRef.current,
    columns2TotalRef,
    columns2TotalRef.current,
    columns2CaseControlRef,
    columns2CaseControlRef.current,
    columns2CohortSitesRef,
    columns2CohortSitesRef.current,
    columns2MTRef,
    columns2MTRef.current,
    props.query,
    columns2CNVRef,
    columns2CNVRef.current,
    overlapRate,
    props.analysisInfo.hasSCIP
  ])

  const defaultColumns: ColumnDef<Variation>[] = React.useMemo(() => {
    let column = []

    if (columns1DefaultRef.current && columns1DefaultRef.current.column)
      column = columns1DefaultRef.current.column

    if (
      props.query &&
      props.query.title &&
      (props.query.title.includes(t('CNV')) ||
        props.query.title.includes(t('Cnv')) ||
        props.query.title.includes('CNV Exon') ||
        props.query.title.includes('Sentieon CNV'))
    ) {
      if (columns1CNVRef.current && columns1CNVRef.current.column) {
        column = columns1CNVRef.current.column
      }
    }

    if (
      props.query &&
      props.query.title &&
      (props.query.title.includes(t('SV')) ||
        props.query.title.includes(t('Sv')))
    ) {
      if (columns1SVRef.current && columns1SVRef.current.column) {
        column = columns1SVRef.current.column
      }
    }

    if (
      props.query &&
      props.query.title &&
      (props.query.title === t('thalassemia') ||
        props.query.title === 'thalassemia' ||
        props.query.title === '地中海贫血')
    ) {
      if (
        columns1ThalassemiaRef.current &&
        columns1ThalassemiaRef.current.column
      ) {
        column = columns1ThalassemiaRef.current.column
      }
    }

    if (
      props.query &&
      props.query.title &&
      (props.query.title === 'thal plot' || props.query.title === '地贫 Plot')
    ) {
      if (
        columns1ThalassemiaPlotRef.current &&
        columns1ThalassemiaPlotRef.current.column
      ) {
        column = columns1ThalassemiaPlotRef.current.column
      }
    }

    if (
      props.query &&
      props.query.title &&
      props.query.title.includes(t('STR'))
    ) {
      if (columns1STRRef.current && columns1STRRef.current.column) {
        column = columns1STRRef.current.column
      }
    }

    if (
      props.query &&
      props.query.title &&
      props.query.title.includes(t('Gene'))
    ) {
      if (columns1TotalRef.current && columns1TotalRef.current.column) {
        column = columns1TotalRef.current.column
      }
    }

    if (
      props.query &&
      props.query.key &&
      props.query.key.includes('case_control')
    ) {
      if (
        columns1CaseControlRef.current &&
        columns1CaseControlRef.current.column
      ) {
        column = columns1CaseControlRef.current.column
      }
    }

    if (
      props.query &&
      props.query.key &&
      props.query.key.includes('cohort_sites')
    ) {
      if (
        columns1CohortSitesRef.current &&
        columns1CohortSitesRef.current.column
      ) {
        column = columns1CohortSitesRef.current.column
      }
    }

    if (
      props.query &&
      props.query.title &&
      (props.query?.title === t('MT') ||
        props.query?.title === 'MT' ||
        props.query?.title === '线粒体')
    ) {
      if (columns1MTRef.current && columns1MTRef.current.column) {
        column = columns1MTRef.current.column
      }
    }

    if (!props.analysisInfo.hasSCIP) {
      column = [...column.filter((item: any) => !item.id?.includes('scip'))]
    }

    return column
  }, [
    columns1DefaultRef,
    columns1DefaultRef.current,
    columns1CNVRef,
    columns1CNVRef.current,
    columns1SVRef,
    columns1SVRef.current,
    columns1ThalassemiaRef,
    columns1ThalassemiaRef.current,
    columns1ThalassemiaPlotRef,
    columns1ThalassemiaPlotRef.current,
    columns1STRRef,
    columns1STRRef.current,
    columns1TotalRef,
    columns1TotalRef.current,
    columns1CaseControlRef,
    columns1CaseControlRef.current,
    columns1CohortSitesRef,
    columns1CohortSitesRef.current,
    columns1MTRef,
    columns1MTRef.current,
    props.query,
    props.analysisInfo.hasSCIP
  ])

  React.useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}')

    if (user && user.filterToggle) {
      setFilterToggle(true)
    } else setFilterToggle(false)
  }, [])

  const [checkList, setCheckList] = React.useState([
    {
      title: '123',
      index: 0,
      checked: true,
      key: 'gene'
    },
    {
      title: '1234',
      index: 1,
      checked: true,
      key: 'gene'
    }
  ])

  const affected_child = React.useMemo(() => {
    const samples = props.analysisInfo.samples as Sample[]

    if (samples && samples.length === 1) {
      return samples[0]
    } else {
      return samples.find((item) => item?.type === 'affected_child')
    }
  }, [props.analysisInfo.samples])

  const Translate = useMutation({
    mutationFn: async (data: TranslateDto) => await translate(data),
    onSuccess: (data, params, context) => {
      //post返回的结果
      // setIsTranslated(true)
      // setOMIMTranslated(data)
    }
  })

  const handleChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckList(
      checkList.map((items) => {
        items.checked = event.target.checked

        return items
      })
    )
  }

  const handleChange2 = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const list = checkList.map((items) => {
      if (items.index === index) {
        items.checked = event.target.checked
      }

      return items
    })

    setCheckList(list)
  }

  const resetRowSelect = () => {
    tableRef.current &&
      tableRef.current.resetRowSelect &&
      tableRef.current.resetRowSelect()
  }

  const handleMenuClick = (
    event: any,
    type:
      | 'list'
      | 'tree'
      | 'filter'
      | 'filter_compare'
      | 'filter_list'
      | 'filter_gnomAD_compare'
      | 'clinvar_info'
      | 'IGV'
      | 'scip_gene'
      | 'scip_clingen'
  ) => {
    setAnchorEl(event.currentTarget)

    setMenuType(type)
  }

  React.useEffect(() => {
    // 搜索 过滤掉没有key的
    setFilterQuery(props.config)
  }, [props.config])

  React.useEffect(() => {
    if (igvOpen) {
      setTimeout(() => {
        if (current?.chrom && current.pos) getIgv(igvLocus)
        else if (
          current?.chrom &&
          current.SV_start &&
          current.SV_end &&
          current.right_genes &&
          current.left_genes
        )
          getIgv(igvLocus)
        else if (current?.chrom && current.SV_start && current.SV_end)
          getIgv(igvLocus)
        else if (current?.chrom && current.start && current.end)
          getIgv(igvLocus)
      }, 0)
    }
  }, [igvOpen, igvLocus])

  const analysisItemType = React.useMemo(() => {
    if (type === 'analyze') {
      localStorage.setItem('analysisItemType', props.query?.key as string)

      // if (props.query?.key === 'family_homozygous') {
      //   localStorage.setItem('analysisItemType', 'family_recessive')

      //   return props.query?.key
      // } else if (props.query?.key === 'family_compound_heterozygous') {
      //   localStorage.setItem('analysisItemType', 'family_recessive')

      return props.query?.key

      // }
    } else {
      localStorage.removeItem('analysisItemType')

      return ''
    }
  }, [props.query])

  const analysisInfo = React.useMemo(
    () => props.analysisInfo,
    [props, props.analysisInfo]
  )

  const querySamples = async (pageNum: number) => {
    const query = {
      pageNum: pageNum + 1,
      pageSize: page.pageSize,
      filter: filterQuery,
      sort: sortQuery
    } as any

    //

    if (query.sort && sortQuery && sortQuery.f && type === 'sample') {
      query.sort = {
        // classification: 1
      }

      // snv clinsig and f_score
      // if (
      //   props.query &&
      //   props.query.title &&
      //   props.query.title.includes('SNV')
      // ) {
      //   query.sort = {
      //     classification: 1
      //   }
      // }
    }

    if (query.sort && sortQuery && sortQuery.f && type === 'analyze') {
      if (analysisItemType === 'big_family') {
        query.sort = {
          f_score: -1
        }
      } else if (
        analysisItemType?.includes('family_') ||
        analysisItemType?.includes('carrier_')
      ) {
        // family_fast_track类型不传sort
        query.sort = {}
      } else {
        query.sort = {
          f_score: -1
        }
      }
    }

    if (
      query.sort &&
      sortQuery &&
      !Object.keys(sortQuery).length &&
      type === 'analyze'
    ) {
      if (analysisItemType === 'big_family')
        query.sort = {
          f_score: -1
        }
    }

    if (query.sort && sortQuery && sortQuery.g) {
      query.sort = {
        f_score: -1
      }
    }

    if (query.sort && sortQuery && sortQuery.dbSNP) {
      query.sort = {
        chrom: sortQuery.dbSNP,
        inputPos: sortQuery.dbSNP
      }
    }

    if (query.sort && sortQuery && sortQuery.G_score) {
      query.sort = {
        ...query.sort,
        g_score: sortQuery.G_score
      }

      delete query.sort.G_score
    }

    if (query.sort && sortQuery && sortQuery.F_score && type === 'sample') {
      query.sort = {
        ...query.sort,
        f_score: sortQuery.F_score
      }
    }

    if (query.sort && sortQuery && sortQuery.F_score && type === 'analyze') {
      query.sort = {
        ...query.sort,
        f_score: sortQuery.F_score
      }

      delete query.sort.F_score
    }

    if (query.sort && sortQuery && sortQuery.grading) {
      query.sort = {
        classification: sortQuery.grading === 1 ? -1 : 1,
        CLINSIG_priority: sortQuery.grading === 1 ? -1 : 1
      }
    }

    if (
      query.sort &&
      sortQuery &&
      sortQuery.ACMG_priority &&
      type === 'sample'
    ) {
      query.sort = {
        ACMG_priority: sortQuery.ACMG_priority === 1 ? -1 : 1,
        ACMG_score: sortQuery.ACMG_priority === 1 ? 1 : -1
      }

      query.filter = {
        ...query.filter,
        acmg_classification: '.'
      }
    }

    if (
      query.sort &&
      sortQuery &&
      sortQuery.ACMG_priority &&
      type === 'analyze'
    ) {
      query.sort = {
        ACMG_priority: sortQuery.ACMG_priority === 1 ? -1 : 1,
        ACMG_score: sortQuery.ACMG_priority === 1 ? 1 : -1
      }

      query.filter = {
        ...query.filter,
        acmg_classification: '.'
      }
    }

    if (
      query.sort &&
      sortQuery &&
      sortQuery.AutoGVP_priority &&
      type === 'sample'
    ) {
      query.sort = {
        autogvp_classification: sortQuery.AutoGVP_priority === 1 ? -1 : 1,
        f_score: -1
      }

      query.filter = {
        ...query.filter,
        autogvp_classification: '.'
      }
    }

    if (
      query.sort &&
      sortQuery &&
      sortQuery.AutoGVP_priority &&
      type === 'analyze'
    ) {
      query.sort = {
        autogvp_classification: sortQuery.AutoGVP_priority === 1 ? -1 : 1,
        f_score: -1
      }

      query.filter = {
        ...query.filter,
        autogvp_classification: '.'
      }
    }

    if (query.sort && sortQuery && sortQuery.classification) {
      query.sort = {
        classification: sortQuery.classification
      }
    }

    if (query.sort && sortQuery && sortQuery.Revel_score) {
      query.sort = {
        REVEL_score: sortQuery.Revel_score
      }

      query.filter = {
        ...query.filter,
        REVEL_score: '.'
      }
    }

    if (query.sort && sortQuery && sortQuery.revel_score) {
      query.sort = {
        REVEL_score: sortQuery.revel_score
      }

      query.filter = {
        ...query.filter,
        REVEL_score: '.'
      }
    }

    if (query.sort && sortQuery && sortQuery.pathogenicity) {
      query.sort = {
        AM_pathogenicity: sortQuery.pathogenicity
      }

      query.filter = {
        ...query.filter,
        AM_pathogenicity: '.'
      }
    }

    if (query.sort && sortQuery && sortQuery.Pathogenicity) {
      query.sort = {
        AM_pathogenicity: sortQuery.Pathogenicity
      }

      query.filter = {
        ...query.filter,
        AM_pathogenicity: '.'
      }
    }

    if (query.sort && sortQuery && sortQuery.SpliceAI_max_score) {
      query.sort = {
        SpliceAI_max_score: sortQuery.SpliceAI_max_score
      }

      query.filter = {
        ...query.filter,
        SpliceAI_max_score: '.'
      }
    }

    if (query.sort && sortQuery && sortQuery.spliceAI_max_score) {
      query.sort = {
        SpliceAI_max_score: sortQuery.spliceAI_max_score
      }

      query.filter = {
        ...query.filter,
        SpliceAI_max_score: '.'
      }
    }

    if (
      query.sort &&
      (props.query?.title?.includes('CNV') ||
        props.query?.title?.includes('Cnv') ||
        props.query?.title?.includes('CNV Exon') ||
        props.query?.title?.includes('Sentieon CNV')) &&
      sortQuery &&
      (sortQuery.f || sortQuery.g)
    ) {
      query.sort = {
        ...sortQuery,
        chrom: 1,
        SV_start: 1
      }
    }

    if (props.query?.title?.includes('Sentieon CNV')) {
      query.filter = {
        ...filterQuery,
        cnvType: 'sentieon'
      }
    }

    if (props.query?.title?.includes('CNV Exon')) {
      query.filter = {
        ...filterQuery,
        cnvType: 'exome_depth'
      }

      const currentSample = props.cnvSampleId
        ? props.analysisInfo.samples?.find(
            (sample: any) => sample.id === props.cnvSampleId
          )
        : null

      const hasSCIP = props.analysisInfo.hasSCIP || currentSample?.hasSCIP

      //
      if (hasSCIP) {
        query.filter.hasScip = true
      }
    }

    if (!sortQuery) {
      query.sort = {}
    }

    if (props.query && props.query.title && props.query.key === '5') {
      query.filter = {
        ...query.filter,
        mtOnly: 1
      }
    }

    //

    if (type === 'sample') {
      if (
        props.query &&
        props.query.title &&
        props.query.title.includes('SNV')
      ) {
        if (props.analysisInfo.pipelineVersion)
          return await getGlsVariants({
            parquetType: 'small',
            variants: {
              id,
              source: 'samples',
              offset: (query.pageNum - 1) * query.pageSize,
              limit: query.pageSize,
              filters: changeV1Filter(query.filter),
              sort_by: changeV1Sorter(query.sort)
            }
          })
        else return await getSamplesSvn(query, Number(id))
      } else if (
        props.query &&
        props.query.title &&
        (props.query.title === t('Fast track') ||
          props.query.title === 'Fast track' ||
          props.query.title === '快捷窗口')
      )
        if (props.analysisInfo.pipelineVersion)
          return await getGlsVariants({
            parquetType: 'small',
            variants: {
              id,
              source: 'samples',
              offset: (query.pageNum - 1) * query.pageSize,
              limit: query.pageSize,
              filters: [
                { field: 'is_fast_track', op: 'eq', value: true },
                ...changeV1Filter(query.filter)
              ],
              sort_by: changeV1Sorter({ ...query.sort })
            }
          })
        else return await getVariantsByFastTrack(query, Number(id))
      else if (
        props.query &&
        props.query.title &&
        (props.query.title === t('MT') ||
          props.query.title === 'MT' ||
          props.query.title === '线粒体')
      ) {
        if (props.analysisInfo.pipelineVersion)
          return await getGlsVariants({
            parquetType: 'mt',
            variants: {
              id,
              source: 'samples',
              offset: (query.pageNum - 1) * query.pageSize,
              limit: query.pageSize,
              filters: changeV1Filter(query.filter),
              sort_by: changeV1Sorter(query.sort)
            }
          })
        else return await getSamplesSvn(query, Number(id))
      } else if (
        props.query &&
        props.query.title &&
        (props.query.title === t('STR') || props.query.title === 'STR')
      )
        if (props.analysisInfo.pipelineVersion)
          return await getGlsVariants({
            parquetType: 'str',
            variants: {
              id,
              source: 'samples',
              offset: (query.pageNum - 1) * query.pageSize,
              limit: query.pageSize,
              filters: changeV1Filter(query.filter),
              sort_by: changeV1Sorter(query.sort)
            }
          })
        else return await getSTRData(query, Number(id))
      else if (
        props.query &&
        props.query.title &&
        props.query.title === t('SV')
      )
        if (props.analysisInfo.pipelineVersion)
          return await getGlsVariants({
            parquetType: 'sv',
            variants: {
              id,
              source: 'samples',
              offset: (query.pageNum - 1) * query.pageSize,
              limit: query.pageSize,
              filters: changeV1Filter(query.filter),
              sort_by: changeV1Sorter(query.sort)
            }
          })
        else return await getSvVariants(query, Number(id))
      else if (
        props.query &&
        props.query.title &&
        (props.query.title === t('thalassemia') ||
          props.query.title === 'thalassemia' ||
          props.query.title === '地中海贫血')
      ) {
        return await fetchThalassemiaDetails(Number(id))
      } else if (
        props.query &&
        props.query.title &&
        (props.query.title === 'thal plot' || props.query.title === '地贫 Plot')
      ) {
        return await fetchThalassemiaExomeDepthResult(Number(id))
      } else {
        if (props.analysisInfo.pipelineVersion) {
          if (props.query?.title?.includes('CNV Exon'))
            return await getGlsVariants({
              parquetType: 'cnv_exomedepth',
              variants: {
                id,
                source: 'samples',
                offset: (query.pageNum - 1) * query.pageSize,
                limit: query.pageSize,
                filters: changeV1Filter(query.filter),
                sort_by: changeV1Sorter(query.sort)
              }
            })
          else {
            return await getGlsVariants({
              parquetType: 'cnv_cnvkit',
              variants: {
                id,
                source: 'samples',
                offset: (query.pageNum - 1) * query.pageSize,
                limit: query.pageSize,
                filters: changeV1Filter(query.filter),
                sort_by: changeV1Sorter(query.sort)
              }
            })
          }
        } else return await getVariantsByCNV(query, Number(id))
      }
    } else {
      //analyze
      if (
        props.query &&
        props.query.key &&
        props.query.key.includes('cohort_sites')
      ) {
        {
          query.analysisItemType = analysisItemType

          return await getAnalysisVariants(query, Number(id))
        }
      } else if (
        props.query &&
        props.query.key &&
        props.query.key.includes('total')
      )
        return await getVariantsByCohort(query, Number(id))
      else if (
        props.query &&
        props.query.key &&
        props.query.key.includes('case_control')
      )
        return await getVariantsByPathway(query, Number(id))

      query.analysisItemType = analysisItemType

      if (analysisItemType === 'family_cnv_exon') {
        query.analysisItemType = 'family_cnv'

        query.filter = {
          ...filterQuery,
          cnvType: 'exome_depth'
        }

        if (props.query?.title?.includes('Sentieon CNV')) {
          query.filter.cnvType = 'sentieon'
        }

        const currentSample = props.cnvSampleId
          ? props.analysisInfo.samples?.find(
              (sample: any) => sample.id === props.cnvSampleId
            )
          : null

        const hasSCIP = props.analysisInfo.hasSCIP || currentSample?.hasSCIP

        //
        if (hasSCIP) {
          query.filter.hasScip = true
        }
        if (props.analysisInfo.pipelineVersion) {
          return await getGlsVariants({
            parquetType: 'cnv_exomedepth',
            variants: {
              id: Number(
                props.cnvSampleId ?? props.analysisInfo.affectedChildId
              ),
              source: 'samples',
              offset: (query.pageNum - 1) * query.pageSize,
              limit: query.pageSize,
              filters: changeV1Filter(query.filter),
              sort_by: changeV1Sorter(query.sort)
            }
          })
        } else
          return await getVariantsByCNV(
            query,
            Number(props.cnvSampleId ?? props.analysisInfo.affectedChildId)
          )
      }

      if (analysisItemType === 'carrier_str') {
        query.analysisItemType = 'carrier_str'

        query.filter = {
          ...filterQuery
        }
        if (props.analysisInfo.pipelineVersion)
          return await getGlsVariants({
            parquetType: 'str',
            variants: {
              id: Number(props.cnvSampleId),
              source: 'samples',
              offset: (query.pageNum - 1) * query.pageSize,
              limit: query.pageSize,
              filters: changeV1Filter(query.filter),
              sort_by: changeV1Sorter(query.sort)
            }
          })
        else return await getSTRData(query, Number(props.cnvSampleId))
      }

      if (
        props.query &&
        props.query.title &&
        (props.query.title === t('STR') || props.query.title === 'STR')
      ) {
        if (props.ProbandList && props.ProbandList.length) {
          const ProbandId = props.ProbandList[0].id

          if (props.analysisInfo.pipelineVersion)
            return await getGlsVariants({
              parquetType: 'str',
              variants: {
                id: Number(ProbandId),
                source: 'samples',
                offset: (query.pageNum - 1) * query.pageSize,
                limit: query.pageSize,
                filters: changeV1Filter(query.filter),
                sort_by: changeV1Sorter(query.sort)
              }
            })
          else return await getSTRData(query, Number(ProbandId))
        } else {
          return {} as any
        }
      }

      if (analysisItemType === 'family_cnv') {
        if (props.analysisInfo.pipelineVersion) {
          if (props.query?.title?.includes('CNV Exon'))
            return await getGlsVariants({
              parquetType: 'cnv_exomedepth',
              variants: {
                id: Number(props.cnvSampleId),
                source: 'samples',
                offset: (query.pageNum - 1) * query.pageSize,
                limit: query.pageSize,
                filters: changeV1Filter(query.filter),
                sort_by: changeV1Sorter(query.sort)
              }
            })
          else {
            return await getGlsVariants({
              parquetType: 'cnv_cnvkit',
              variants: {
                id: Number(props.cnvSampleId),
                source: 'samples',
                offset: (query.pageNum - 1) * query.pageSize,
                limit: query.pageSize,
                filters: changeV1Filter(query.filter),
                sort_by: changeV1Sorter(query.sort)
              }
            })
          }
        } else return await getVariantsByCNV(query, Number(props.cnvSampleId))
      }

      if (
        analysisItemType === 'carrier_cnv' ||
        analysisItemType === 'big_family_cnv'
      ) {
        delete query.analysisItemType

        if (props.query?.title?.includes('Sentieon CNV')) {
          query.filter.cnvType = 'sentieon'
        }
        if (props.analysisInfo.pipelineVersion) {
          return await getGlsVariants({
            parquetType: 'cnv_exomedepth',
            variants: {
              id: Number(props.cnvSampleId),
              source: 'samples',
              offset: (query.pageNum - 1) * query.pageSize,
              limit: query.pageSize,
              filters: changeV1Filter(query.filter),
              sort_by: changeV1Sorter(query.sort)
            }
          })
        } else return await getVariantsByCNV(query, Number(props.cnvSampleId))
      }

      if (query.sort && !Object.getOwnPropertyNames(query.sort).length)
        if (analysisItemType === 'family_cnv') {
          query.sort = {
            f_score: -1,
            gene_min_clinsig: 1,
            gene: 1
          }
        } else if (analysisItemType === 'family_fast_track') {
          // family_fast_track类型不传sort
          query.sort = {}
        } else {
          query.sort = {
            classification: 1
          }
        }

      if (
        ids &&
        group &&
        typeof ids === 'string' &&
        typeof group === 'string'
      ) {
        if (query.filter && Object.keys(query.filter).length)
          query.filter = {
            ...query.filter,
            sampleIdsProtocol: FilterProtocol.OR,
            sampleIds: ids.split(',').map((item) => Number(item)),
            sampleGroupIds: group.split('|').map((item) => Number(item))
          }
        else
          query.filter = {
            ...query.filter,
            sampleIdsProtocol: FilterProtocol.OR,
            sampleIds: ids.split(',').map((item) => Number(item)),
            sampleGroupIds: group.split('|').map((item) => Number(item))
          }
      }

      if (props.analysisInfo.pipelineVersion) {
        const newFilter = {
          ...query.filter
        }
        const newSort = {
          ...query.sort
        }
        const variants: NObject = {
          id,
          source: 'analysis',
          offset: (query.pageNum - 1) * query.pageSize,
          limit: query.pageSize
        }
        newFilter.fmaxscoreValue = newFilter.fscoreValue
        newFilter.gmaxscoreValue = newFilter.gscoreValue
        if (newFilter.sampleSource && newFilter.sampleSource.length) {
          variants.sample_presence = {
            sample_ids: newFilter.sampleSource.map(
              (i: string) => i.split('/')[0]
            ),
            mode: 'exclusive'
          }

          delete newFilter.sampleSource
        }
        if (newSort.f_score) {
          newSort.f_score_max = newSort.f_score
          delete newSort.f_score
        }
        if (newSort.g_score) {
          newSort.g_score_max = newSort.g_score
          delete newSort.g_score
        }
        delete newFilter.gscoreValue
        delete newFilter.fscoreValue
        if (
          analysisItemType === 'family_mt' ||
          analysisItemType === 'carrier_mt'
        ) {
          return await getGlsVariants({
            parquetType: 'joint_mt',
            variants: {
              ...variants,
              filters: changeV1Filter(newFilter),
              sort_by: changeV1Sorter(newSort)
            }
          })
        } else {
          const params = {
            ...variants,
            filters: [
              {
                field: switchAnalysisType(analysisItemType || ''),
                op: 'eq',
                value: true
              },
              ...changeV1Filter(newFilter)
            ],
            sort_by: changeV1Sorter(newSort)
          }

          if (
            analysisItemType === 'carrier_all_sites' ||
            analysisItemType === 'family_raw_data'
          ) {
            params.filters = [...changeV1Filter(newFilter)]
          }
          return await getGlsVariants({
            parquetType: 'joint',
            variants: params
          })
        }
      } else return await getAnalysisVariants(query, Number(id))
    }
  }

  const queryFilterGeneSamples = async (gene: string) => {
    const query: NObject = {
      pageNum: 1,
      pageSize: 100,
      filter: {},
      sort: {}
    }

    if (gene) {
      query.filter = {
        geneNameIn: [gene]
      }
    }

    if (type === 'sample') {
      if (props.query && props.query.title && props.query.title.includes('SNV'))
        if (props.analysisInfo.pipelineVersion)
          return await getGlsVariants({
            parquetType: 'small',
            variants: {
              id,
              source: 'samples',
              offset: (query.pageNum - 1) * query.pageSize,
              limit: query.pageSize,
              filters: changeV1Filter(query.filter),
              sort_by: changeV1Sorter(query.sort)
            }
          })
        else return await getSamplesSvn(query, Number(id))
      else if (
        props.query &&
        props.query.key &&
        (props.query.title === t('Fast track') ||
          props.query.title === 'Fast track' ||
          props.query.title === '快捷窗口')
      )
        if (props.analysisInfo.pipelineVersion)
          return await getGlsVariants({
            parquetType: 'small',
            variants: {
              id,
              source: 'samples',
              offset: (query.pageNum - 1) * query.pageSize,
              limit: query.pageSize,
              filters: [...changeV1Filter(query.filter)],
              sort_by: changeV1Sorter({ ...query.sort })
            }
          })
        else return await getSamplesSvn(query, Number(id))
      else if (
        props.query &&
        props.query.title &&
        (props.query.title === t('MT') ||
          props.query.title === 'MT' ||
          props.query.title === '线粒体')
      )
        if (props.analysisInfo.pipelineVersion)
          return await getGlsVariants({
            parquetType: 'mt',
            variants: {
              id,
              source: 'samples',
              offset: (query.pageNum - 1) * query.pageSize,
              limit: query.pageSize,
              filters: changeV1Filter(query.filter),
              sort_by: changeV1Sorter(query.sort)
            }
          })
        else
          return await getSamplesSvn(
            {
              ...query,
              filter: {
                ...query.filter,
                mtOnly: true
              }
            },
            Number(id)
          )
      else if (
        props.query &&
        props.query.title &&
        (props.query.title === t('STR') || props.query.title === 'STR')
      )
        if (props.analysisInfo.pipelineVersion)
          return await getGlsVariants({
            parquetType: 'str',
            variants: {
              id,
              source: 'samples',
              offset: (query.pageNum - 1) * query.pageSize,
              limit: query.pageSize,
              filters: changeV1Filter(query.filter),
              sort_by: changeV1Sorter(query.sort)
            }
          })
        else return await getSTRData(query, Number(id))
      else if (
        props.query &&
        props.query.title &&
        props.query.title === t('SV')
      )
        if (props.analysisInfo.pipelineVersion)
          return await getGlsVariants({
            parquetType: 'sv',
            variants: {
              id,
              source: 'samples',
              offset: (query.pageNum - 1) * query.pageSize,
              limit: query.pageSize,
              filters: changeV1Filter(query.filter),
              sort_by: changeV1Sorter(query.sort)
            }
          })
        else return await getSvVariants(query, Number(id))
      else {
        if (props.analysisInfo.pipelineVersion) {
          if (props.query?.title?.includes('CNV Exon'))
            return await getGlsVariants({
              parquetType: 'cnv_exomedepth',
              variants: {
                id,
                source: 'samples',
                offset: (query.pageNum - 1) * query.pageSize,
                limit: query.pageSize,
                filters: changeV1Filter(query.filter),
                sort_by: changeV1Sorter(query.sort)
              }
            })
          else {
            return await getGlsVariants({
              parquetType: 'cnv_cnvkit',
              variants: {
                id,
                source: 'samples',
                offset: (query.pageNum - 1) * query.pageSize,
                limit: query.pageSize,
                filters: changeV1Filter(query.filter),
                sort_by: changeV1Sorter(query.sort)
              }
            })
          }
        } else return await getVariantsByCNV(query, Number(id))
      }
    } else {
      //analyze
      if (
        props.query &&
        props.query.key &&
        props.query.key.includes('cohort_sites')
      ) {
        {
          query.analysisItemType = analysisItemType

          return await getAnalysisVariants(query, Number(id))
        }
      } else if (
        props.query &&
        props.query.key &&
        props.query.key.includes('total')
      )
        return await getVariantsByCohort(query, Number(id))
      else if (
        props.query &&
        props.query.key &&
        props.query.key.includes('case_control')
      )
        return await getVariantsByPathway(query, Number(id))

      query.analysisItemType = analysisItemType

      if (analysisItemType === 'family_cnv_exon') {
        query.analysisItemType = 'family_cnv'
      }

      if (analysisItemType === 'family_cnv') {
        if (props.analysisInfo.pipelineVersion) {
          return await getGlsVariants({
            parquetType: 'cnv_exomedepth',
            variants: {
              id: Number(props.analysisInfo.affectedChildId),
              source: 'samples',
              offset: (query.pageNum - 1) * query.pageSize,
              limit: query.pageSize,
              filters: changeV1Filter(query.filter),
              sort_by: changeV1Sorter(query.sort)
            }
          })
        } else
          return await getVariantsByCNV(
            query,
            Number(props.analysisInfo.affectedChildId)
          )
      }

      if (
        analysisItemType === 'family_fast_track' ||
        analysisItemType === 'family_x_linked' ||
        analysisItemType === 'family_denovo' ||
        analysisItemType === 'family_homozygous' ||
        analysisItemType === 'family_compound_heterozygous' ||
        analysisItemType === 'family_mt' ||
        analysisItemType === 'family_dominant'
      ) {
        query.analysisItemType = 'family_raw_data'
      } else if (
        analysisItemType === 'carrier_hom_hemi' ||
        analysisItemType === 'carrier_compound_heterozygous' ||
        analysisItemType === 'carrier_gls' ||
        analysisItemType === 'carrier_acmg' ||
        analysisItemType === 'carrier_fast_track'
      ) {
        query.analysisItemType = 'carrier_all_sites'
      }

      if (query.sort && !Object.getOwnPropertyNames(query.sort).length)
        if (analysisItemType === 'family_cnv')
          query.sort = {
            f_score: -1,
            gene_min_clinsig: 1,
            gene: 1
          }
        else
          query.sort = {
            classification: 1
          }

      if (props.analysisInfo.pipelineVersion) {
        const newFilter = {
          ...query.filter
        }
        const newSort = {
          ...query.sort
        }
        const variants: NObject = {
          id,
          source: 'analysis',
          offset: (query.pageNum - 1) * query.pageSize,
          limit: query.pageSize
        }
        newFilter.fmaxscoreValue = newFilter.fscoreValue
        newFilter.gmaxscoreValue = newFilter.gscoreValue
        if (newFilter.sampleSource && newFilter.sampleSource.length) {
          variants.sample_presence = {
            sample_ids: newFilter.sampleSource.map(
              (i: string) => i.split('/')[0]
            ),
            mode: 'exclusive'
          }

          delete newFilter.sampleSource
        }
        if (newSort.f_score) {
          newSort.f_score_max = newSort.f_score
          delete newSort.f_score
        }
        if (newSort.g_score) {
          newSort.g_score_max = newSort.g_score
          delete newSort.g_score
        }
        delete newFilter.gscoreValue
        delete newFilter.fscoreValue
        if (analysisItemType === 'family_mt') {
          return await getGlsVariants({
            parquetType: 'joint_mt',
            variants: {
              ...variants,
              filters: changeV1Filter(newFilter),
              sort_by: changeV1Sorter(newSort)
            }
          })
        } else
          return await getGlsVariants({
            parquetType: 'joint',
            variants: {
              ...variants,
              filters: [
                {
                  field: switchAnalysisType('family_raw_data'),
                  op: 'eq',
                  value: true
                },
                ...changeV1Filter(newFilter)
              ],
              sort_by: changeV1Sorter(newSort)
            }
          })
      } else return await getAnalysisVariants(query, Number(id))
    }
  }

  React.useEffect(() => {
    const fetchData = async (url: string, setData: any) => {
      try {
        const response = await fetch(url)
        const text = await response.text()

        // Split the text by new lines to get rows
        const rows = text.split('\n').filter((row) => row.trim() !== '')

        // Initialize an array to hold JSON objects
        const jsonData = []

        // Get headers from the first row
        const headers = rows[0].split('\t').map((header) => header.trim())

        // Iterate over the remaining rows and create JSON objects
        for (let i = 1; i < rows.length; i++) {
          const values = rows[i].split('\t').map((value) => value.trim())
          const jsonObject: NObject = {}

          headers.forEach((header, index) => {
            jsonObject[header] = values[index]
          })

          jsonData.push(jsonObject)
        }

        // Set the state with the JSON data
        setData(jsonData)
      } catch (error) {
        console.error('Error fetching or parsing TSV file:', error)
      }
    }

    if (
      props?.query?.title?.includes(t('CNV')) ||
      props?.query?.title?.includes('CNV Exon')
    ) {
      if (props.analysisInfo.genomeBuild === 'hg19')
        fetchData('/GRCh37_cytoband.tsv', setHg19JsonData)
      else fetchData('/GRCh38_cytoband.tsv', setHg38JsonData)
    }
  }, [props.analysisInfo.genomeBuild, props?.query?.title])

  const getFilterGene = useMutation({
    mutationKey: 'getFilterGene',
    mutationFn: async (gene: string) => await queryFilterGeneSamples(gene),
    onSuccess: (data) => {
      if (data.data && data.data.list) {
        setFilterGeneData(
          data.data.list.map((items: any) => {
            const tempOMIM = OMIMs.find((item) => item.geneName === items.gene)

            if (tempOMIM) items.OMIM = tempOMIM

            return items
          })
        )
      } else if (data.items) {
        setFilterGeneData(
          data.items.map((items: any) => {
            const tempOMIM = OMIMs.find((item) => item.geneName === items.gene)

            if (tempOMIM) items.OMIM = tempOMIM

            return items
          })
        )
      }
    }
  })

  const getOMIM = useMutation({
    mutationFn: async (data: { geneNames: string[]; articleParams: any[] }) =>
      await fetchOMIM({ geneNames: data.geneNames }),
    onSuccess: async (datas: VariantDetailOmimData[], params) => {
      //post返回的结果
      const data = await Promise.all(
        datas.map(async (items) => {
          if (items.omimData)
            items.omimData = await Promise.all(
              items.omimData?.map(async (item: any) => {
                if (!item.phenoName_cn && i18n.language === 'zh') {
                  // const phenoName_cn = await Translate.mutateAsync({
                  //   sourceLanguage: 'en',
                  //   targetLanguage: 'zh',
                  //   sourceText: item.phenoName
                  // })

                  return {
                    ...item,
                    isCheck: true

                    // phenoName_cn
                  }
                } else {
                  return {
                    ...item,
                    isCheck: true
                  }
                }
              })
            )

          return items
        })
      )

      //

      setOMIM([...OMIMs, ...data])

      if (
        props.query &&
        props.query.title &&
        !(
          props.query.title.includes(t('CNV')) ||
          props.query.title.includes(t('Cnv')) ||
          props.query.title.includes(t('SV')) ||
          props.query.title.includes(t('Sv')) ||
          props.query?.title?.includes('CNV Exon') ||
          props.query?.title?.includes('Sentieon CNV')
        )
      ) {
        const articleParams = params.articleParams
          .map((items) => {
            const temp = data.find((item) => item.geneName === items.gene)
            if (temp) items.omimPubmed = temp.pubmedIds

            return items
          })
          .filter((item) => item && item.omimPubmed)
        if (articleParams && articleParams.length)
          BatchArticle.mutateAsync(articleParams)
      }
    }
  })

  const getHitoryByGeneAndChromNew = useMutation({
    mutationFn: async (
      conditions: {
        gene: string
        chromosomePosition: string
      }[]
    ) =>
      await findHitoryByGeneAndChromNew({
        conditions
      }),
    onSuccess: async (datas: HistoryReportsResultsNew[]) => {
      //post返回的结果

      setHistorys([...Historys, ...datas])
    }
  })

  const getMitomap = useMutation({
    mutationFn: async (data: {
      mitoMapParams: GetMitoMapDataDto[]
      articleParams: any[]
    }) => await fetchMitomap(data.mitoMapParams),
    onSuccess: (datas: IMitoMapSearchSource[], params) => {
      //post返回的结果
      setMitoMap(datas)

      if (props.query && props.query.key && props.query.key === '5') {
        const articleParams = params.articleParams
          .map((items) => {
            const temp = datas.find((item) => item.key === items.key)
            if (temp) items.omimPubmed = temp.pubmed_ids

            return items
          })
          .filter((item) => item && item.omimPubmed)
        if (articleParams && articleParams.length)
          BatchArticle.mutateAsync(articleParams)
      }
    }
  })

  const getIndex = useMutation({
    mutationFn: async (data: GetManyVariantIndexDto) =>
      await getVariantIndexData(data),
    onSuccess: (datas: IVariantIndexResult[]) => {
      //post返回的结果
      // setOMIM(datas)
      setIndexs(datas)
    }
  })

  const getGlsIndex = useMutation({
    mutationFn: async (data: { variant_ids: string[]; genome: string }) =>
      await getGlsVariantsIndex(data),
    onSuccess: (datas: {
      genome: string
      items: any[]
      sample_totals: any
    }) => {
      //post返回的结果
      // setOMIM(datas)
      if (datas.items && datas.items.length) {
        const items = datas.items
        const sample_totals = datas.sample_totals
        const newData = items.map((i) => {
          return {
            ...i,
            ...sample_totals
          }
        })
        setGlsIndexs(newData)
      }
    }
  })

  const getGeneIndex = useMutation({
    mutationFn: async (data: GetManyGeneIndexDto) =>
      await getVariantGeneIndexData(data),
    onSuccess: (datas: any[]) => {
      //post返回的结果
      // setOMIM(datas)
      setGeneIndexs(datas)
    }
  })

  const Article = useMutation({
    mutationFn: async (data: GetArticlesDto) => await getArticles(data),
    onSuccess: (datas: any) => {
      //post返回的结果
      // setOMIM(datas)
      // setArticles(datas)
    }
  })
  const BatchArticle = useMutation({
    mutationFn: async (data: GetArticlesDto[]) => await getBatchArticles(data),
    onSuccess: (datas: any) => {
      //post返回的结果
      // setOMIM(datas)
      if (datas) setArticles(datas.articles)
    }
  })
  const LitVarArticle = useMutation({
    mutationFn: async (rsId: string) => await getLitvarArticles(rsId),
    onSuccess: (datas: any) => {
      //post返回的结果
    }
  })
  const CitationsArticle = useMutation({
    mutationFn: async (pubmedId: string) =>
      await getCitationsByVariation({
        id: pubmedId
      }),
    onSuccess: (datas: any) => {
      //post返回的结果
    }
  })
  const BatchLitVarArticle = useMutation({
    mutationFn: async (rsIds: string[]) => await getBatchLitvarArticles(rsIds),
    onSuccess: (datas: any) => {
      //post返回的结果
      // setOMIM(datas)
      if (datas) setLitVarArticles(datas.litVarArticles)
    }
  })
  const GoogleArticle = useMutation({
    mutationFn: async (data: GetArticlesDto) => await getGoogleArticles(data),
    onSuccess: (datas: any) => {
      //post返回的结果
      // setOMIM(datas)
      setGoogleArticle(datas)
    }
  })

  const judgeType = (str: string, arr: any[]) => {
    if (str.includes('child') && !str.includes('//')) {
      return 'C'
    } else if (str.includes('child') && str.includes('//')) {
      return `C${str.split('//')[1]}`
    } else if (str.includes('mother')) {
      return 'M'
    } else if (str.includes('father')) {
      return 'F'
    } else {
      return 'O'
    }
  }

  const getIgv = async (igvLocus: string) => {
    //

    if (
      (analysisInfo && analysisInfo.bamFile) ||
      analysisInfo.sampleType === 'fastq'
    ) {
      const urls = await fetchBamUrl.mutateAsync(id)

      //

      if (urls && urls.bamUrl && urls.baiUrl) {
        import('igv/dist/igv.esm.js').then((mod) => {
          const igv = mod.default
          const locus = igvLocus
          const igvDiv = document.getElementById('igv-div')
          const {
            bamUrl,
            baiUrl,
            refGeneUrl,
            cytoBandUrl,
            fastaUrl,
            fastaIndexUrl,
            aliasUrl
          } = urls

          // let bamUrl = `https://glsofort.oss-cn-shenzhen.aliyuncs.com/bam_uploads/${analysisInfo.bamFile}`
          // let bamIndexUrl = `https://glsofort.oss-cn-shenzhen.aliyuncs.com/bam_uploads/${analysisInfo.bamFile}.bai`

          // if (analysisInfo.sampleType === 'fastq') {
          //   bamUrl = `https://glsofort.oss-cn-shenzhen.aliyuncs.com/samples/${id}/fastq_results/${analysisInfo.prefix}.realigned.bam`

          //   bamIndexUrl = `https://glsofort.oss-cn-shenzhen.aliyuncs.com/samples/${id}/fastq_results/${analysisInfo.prefix}.realigned.bam.bai`
          // }

          //

          const options = {
            genome: analysisInfo.genomeBuild ?? 'hg19',
            locus: locus,
            showKaryo: false,
            showIdeogram: true,
            showNavigation: true,
            showRuler: true,
            showCenterGuide: true,

            reference: {
              id: `${analysisInfo.genomeBuild ?? 'hg19'}`,
              name: `Human ${analysisInfo.genomeBuild ?? 'hg19'}`,
              fastaURL: fastaUrl,
              indexURL: fastaIndexUrl,
              cytobandURL: cytoBandUrl,
              aliasURL: aliasUrl,
              tracks: [
                {
                  name: 'Refseq Genes',
                  format: 'refgene',
                  url: refGeneUrl,
                  order: 2,
                  displayMode: 'EXPANDED'
                }
              ]
            },
            tracks: [
              {
                name: analysisInfo.name,
                colorBy: 'strand',
                displayMode: 'EXPANDED',
                filename: 'name',
                format: 'bam',
                indexURL: baiUrl,
                label: 'Sample',
                noSpinner: true,
                order: 1,
                sourceType: 'file',
                type: 'alignment',
                url: bamUrl,
                visibilityWindow: 300000000
              }
            ]
          }

          igv.createBrowser(igvDiv, options).then(function (browser: any) {
            //
          })
        })
      }
    } else if (
      analysisInfo.analysisType === 'family_analysis' ||
      analysisInfo.analysisType === 'big_family' ||
      analysisInfo.analysisType === 'carrier'
    ) {
      let refGeneUrl = ''
      let cytoBandUrl = ''
      let fastaUrl = ''
      let fastaIndexUrl = ''
      let aliasUrl = ''

      const fqSamples = analysisInfo.samples?.filter(
        (item: any) => item && item.sampleType === 'fastq'
      ) as any[]

      const tracks = (
        await Promise.all(
          fqSamples.map(async (item: any) => {
            const urls = await fetchBamUrl.mutateAsync(item.id)

            //

            if (urls && urls.bamUrl && urls.baiUrl) {
              const bamUrl = urls.bamUrl
              const baiUrl = urls.baiUrl

              refGeneUrl = urls.refGeneUrl

              cytoBandUrl = urls.cytoBandUrl

              fastaUrl = urls.fastaUrl

              fastaIndexUrl = urls.fastaIndexUrl

              aliasUrl = urls.aliasUrl

              return {
                name: item.name,
                colorBy: 'strand',
                displayMode: 'EXPANDED',
                filename: 'name',
                format: 'bam',
                indexURL: baiUrl,

                // label: 'Sample',
                noSpinner: true,
                order: 1,
                sourceType: 'file',
                type: 'alignment',
                url: bamUrl,
                visibilityWindow: 300000000
              }
            }
          })
        )
      ).filter((i) => i && i.url && i.indexURL)

      //

      if (tracks && tracks.length) {
        import('igv/dist/igv.esm.js').then((mod) => {
          const igv = mod.default
          const locus = igvLocus
          const igvDiv = document.getElementById('igv-div')

          const options = {
            genome: `${analysisInfo.genomeBuild ?? 'hg19'}`,
            locus: locus,
            showKaryo: false,
            showIdeogram: true,
            showNavigation: true,
            showRuler: true,
            showCenterGuide: true,
            reference: {
              id: `${analysisInfo.genomeBuild ?? 'hg19'}`,
              name: `Human ${analysisInfo.genomeBuild ?? 'hg19'}`,
              fastaURL: fastaUrl,
              indexURL: fastaIndexUrl,
              cytobandURL: cytoBandUrl,
              aliasURL: aliasUrl,
              tracks: [
                {
                  name: 'Refseq Genes',
                  format: 'refgene',
                  url: refGeneUrl,
                  order: 2,
                  displayMode: 'EXPANDED'
                }
              ]
            },
            tracks
          }

          igv.createBrowser(igvDiv, options).then(function (browser: any) {
            //
          })
        })
      }
    }
  }
  const getCnvManual = useMutation({
    mutationFn: async (id: number) => await getCnvManualData(id),
    onSuccess: (data: any[]) => {
      //post返回的结果
      // setOMIM(datas)

      setCnvManual(data)
    }
  })

  const fetchGeneDiseaseSpecific = useMutation({
    mutationFn: async (data: GetGeneDiseaseSpecificDto) =>
      await getGeneDiseaseSpecific(data),
    onSuccess: (datas: GetGeneDiseaseSpecificDto[]) => {
      //post返回的结果

      setGeneDiseaseSpecific(datas)
    }
  })

  const AnalyzeVariant = useMutation({
    mutationFn: async (data: AnalyzeVariantDto) => await analyzeVariant(data),
    onSuccess: (datas: any) => {
      //post返回的结果

      setAnalyzeVariant(datas)
    },
    onError: () => {
      setAnalyzeVariant(null)

      setIsFinish(false)
    }
  })

  const fetchBamUrl = useMutation({
    mutationFn: async (id: any) => await getBamUrl(id)
  })

  const EditClass = useMutation({
    mutationFn: async (data: UpdateVariantClassificationDto) =>
      await editClass(data),
    onSuccess: (datas: any, params) => {
      //post返回的结果
      if (datas) {
        const classification = params.classification
        const temp = data.find((items) => items._id === current?._id)

        if (temp) {
          temp.user_classification = classification

          setData(data)
        }

        messageRef?.current?.handleClick(t('Update successful'), 'success')
      } else messageRef?.current?.handleClick(t('Update failed'), 'error')
    },
    onError: () => {
      messageRef?.current?.handleClick(t('Update failed'), 'error')
    }
  })

  const EditGlsClass = useMutation({
    mutationFn: async (data: any) => await putGlsCuration(data),
    onSuccess: (datas: any, params) => {
      //post返回的结果
      if (datas) {
        const classification = params.gls_classification
        const temp = data.find((items) => items.pair_id === current?.pair_id)

        if (temp) {
          temp.user_classification = classification

          setData(data)
        }

        messageRef?.current?.handleClick(t('Update successful'), 'success')
      } else messageRef?.current?.handleClick(t('Update failed'), 'error')
    },
    onError: () => {
      messageRef?.current?.handleClick(t('Update failed'), 'error')
    }
  })

  const DeleteGlsClass = useMutation({
    mutationFn: async (data: any) => await deleteGlsCuration(data),
    onSuccess: (datas: any, params) => {
      //post返回的结果
      if (datas) {
        const classification = null
        const temp = data.find((items) => items.pair_id === current?.pair_id)

        if (temp) {
          temp.user_classification = classification

          setData(data)
        }

        messageRef?.current?.handleClick(t('Update successful'), 'success')
      } else messageRef?.current?.handleClick(t('Update failed'), 'error')
    },
    onError: () => {
      messageRef?.current?.handleClick(t('Update failed'), 'error')
    }
  })

  const EditAcmgClass = useMutation({
    mutationFn: async (data: UpdateVariantACMGClassificationDto) =>
      await editAcmgClass(data),
    onSuccess: (datas: any, params) => {
      //post返回的结果
      if (datas) {
        const classification = params.classification
        const evidences = params.evidences
        const temp = data.find((items) => items._id === current?._id)

        if (temp) {
          temp.user_acmg_classification = classification

          temp.acmg_evidences = evidences

          setData(data)
        }

        messageRef?.current?.handleClick(t('Update successful'), 'success')
      } else messageRef?.current?.handleClick(t('Update failed'), 'error')
    },
    onError: () => {
      messageRef?.current?.handleClick(t('Update failed'), 'error')
    }
  })
  const EditGlsACMGClass = useMutation({
    mutationFn: async (data: any) => await putAcmgCurations(data),
    onSuccess: (datas: any, params) => {
      //post返回的结果
      if (datas) {
        const classification = datas.acmg_classification
        const evidences = params.evidences
        const temp = data.find((items) => items.pair_id === current?.pair_id)

        if (temp) {
          temp.user_acmg_classification = classification

          temp.acmg_evidences = evidences

          setData(data)
        }

        messageRef?.current?.handleClick(t('Update successful'), 'success')
      } else messageRef?.current?.handleClick(t('Update failed'), 'error')
    },
    onError: () => {
      messageRef?.current?.handleClick(t('Update failed'), 'error')
    }
  })

  const { fetchNextPage, isFetching, isLoading } = useInfiniteQuery(
    ['data', sortQuery, filterQuery, analysisItemType, props.query?.key], //adding sorting state as key causes table to reset and fetch from new beginning upon sort
    async ({ pageParam = 0 }) => {
      return querySamples(pageParam)
    },
    {
      getNextPageParam: (_lastGroup, groups) => groups.length,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setBackop(false)

        //
        if (
          props.query &&
          props.query.title &&
          (props.query.title === t('thalassemia') ||
            props.query.title === 'thalassemia' ||
            props.query.title === '地中海贫血')
        ) {
          const variants =
            data?.pages
              ?.flatMap((page) => page)
              .map((i: any) => {
                i.id = i.id
                  ? i.id
                  : i._id
                  ? i._id
                  : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

                i.key = i._id
                  ? i._id
                  : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

                return i
              }) ?? []

          setData(variants)

          setTotalCount(variants.length ?? 0)

          setVariantCount(variants.length ?? 0)

          //
        } else if (
          props.query &&
          props.query.title &&
          (props.query.title === 'thal plot' ||
            props.query.title === '地贫 Plot')
        ) {
          const datas =
            data?.pages
              ?.flatMap((page) => page)
              .map((i: any) => {
                return i
              }) ?? []

          const variants = datas.length ? datas[0].data : []
          const plot = datas.length ? datas[0].plot : ''

          setThalassemiaPlot(plot)

          setData(variants)

          setTotalCount(variants.length ?? 0)

          setVariantCount(variants.length ?? 0)

          //
        } else if (
          props.query &&
          props.query.title &&
          (props.query.title.includes('SNV') ||
            props.query.title === t('MT') ||
            props.query.title === 'MT' ||
            props.query.title === '线粒体' ||
            props.query.title === t('Fast track') ||
            props.query.title === 'Fast track' ||
            props.query.title === '快捷窗口' ||
            props.query.title === t('SV') ||
            props.query.title.includes('CNV') ||
            props.query.title.includes(t('STR')) ||
            props.query.key?.includes('family_') ||
            props.query.key?.includes('carrier_'))
        ) {
          //
          if (props.analysisInfo.pipelineVersion) {
            console.log('data', data)
            const variants =
              data?.pages
                ?.flatMap((page) => page.items)
                .map((i: any) => {
                  i.id = i.id
                    ? i.id
                    : i._id
                    ? i._id
                    : i.start && i.end
                    ? `${i.chrom}_${i.start}_${i.end}_${i.sv_type}`
                    : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

                  i.key = i._id
                    ? i._id
                    : i.start && i.end
                    ? `${i.chrom}_${i.start}_${i.end}_${i.sv_type}`
                    : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

                  return i
                }) ?? []
            const newOMIM = data?.pages?.flatMap(
              (page) => page.omim_gene_data
            )[0]
            setNewOMIM(newOMIM)
            successCallBack(
              variants,
              data?.pages?.[0]?.total_records ?? 0,
              data?.pages?.[0]?.total_variants ?? 0
            )
          } else {
            const variants =
              data?.pages
                ?.flatMap((page) => page.data.list)
                .map((i: any) => {
                  i.id = i.id
                    ? i.id
                    : i._id
                    ? i._id
                    : i.SV_start && i.SV_end
                    ? `${i.chrom}_${i.SV_start}_${i.SV_end}_${i.SV_type}`
                    : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

                  i.key = i._id
                    ? i._id
                    : i.SV_start && i.SV_end
                    ? `${i.chrom}_${i.SV_start}_${i.SV_end}_${i.SV_type}`
                    : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

                  return i
                }) ?? []
            successCallBack(
              variants,
              data?.pages?.[0]?.data?.totalCount ?? 0,
              data?.pages?.[0]?.data?.variantCount ?? 0
            )
          }
        } else {
          const variants =
            data?.pages
              ?.flatMap((page) => page.data.list)
              .map((i: any) => {
                i.id = i.id
                  ? i.id
                  : i._id
                  ? i._id
                  : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

                i.key = i._id
                  ? i._id
                  : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

                return i
              }) ?? []
          successCallBack(
            variants,
            data?.pages?.[0]?.data?.totalCount ?? 0,
            data?.pages?.[0]?.data?.variantCount ?? 0
          )
        }
      },
      onError: (data) => {
        //
        setBackop(false)
      },

      initialData: () => ({
        pages: [],

        pageParams: [0]
      })
    }
  )

  const getVariants = useMutation({
    mutationFn: async (pageParam: number) => {
      return await querySamples(pageParam)
    },
    onSuccess: (data: any) => {
      //
      setBackop(false)

      if (
        props.query &&
        props.query.title &&
        (props.query.title === t('thalassemia') ||
          props.query.title === 'thalassemia' ||
          props.query.title === '地中海贫血')
      ) {
        const variants =
          data?.data?.list.map((i: any) => {
            i.id = i.id
              ? i.id
              : i._id
              ? i._id
              : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

            i.key = i._id
              ? i._id
              : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

            return i
          }) ?? []

        setData(variants)

        setTotalCount(variants.length ?? 0)

        setVariantCount(variants.length ?? 0)

        //
      } else if (
        props.query &&
        props.query.title &&
        (props.query.title === 'thal plot' || props.query.title === '地贫 Plot')
      ) {
        const datas =
          data?.data?.list.map((i: any) => {
            return i
          }) ?? []

        const variants = datas.length ? datas[0].data : []
        const plot = datas.length ? datas[0].plot : ''

        setThalassemiaPlot(plot)

        setData(variants)

        setTotalCount(variants.length ?? 0)

        setVariantCount(variants.length ?? 0)

        //
      } else if (
        props.query &&
        props.query.title &&
        (props.query.title.includes('SNV') ||
          props.query.title === t('MT') ||
          props.query.title === 'MT' ||
          props.query.title === '线粒体' ||
          props.query.title === t('Fast track') ||
          props.query.title === 'Fast track' ||
          props.query.title === '快捷窗口' ||
          props.query.title === t('SV') ||
          props.query.title.includes('CNV') ||
          props.query.title.includes(t('STR')) ||
          props.query.key?.includes('family_') ||
          props.query.key?.includes('carrier_'))
      ) {
        //
        if (props.analysisInfo.pipelineVersion) {
          const variants =
            data?.items.map((i: any) => {
              i.id = i.id
                ? i.id
                : i._id
                ? i._id
                : i.sv_start && i.sv_end
                ? `${i.chrom}_${i.sv_start}_${i.sv_end}_${i.sv_type}`
                : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

              i.key = i._id
                ? i._id
                : i.sv_start && i.sv_end
                ? `${i.chrom}_${i.sv_start}_${i.sv_end}_${i.sv_type}`
                : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

              return i
            }) ?? []
          successCallBack(
            variants,
            data?.total_records ?? 0,
            data?.total_variants ?? 0
          )
        } else {
          const variants =
            data?.data?.list.map((i: any) => {
              i.id = i.id
                ? i.id
                : i._id
                ? i._id
                : i.SV_start && i.SV_end
                ? `${i.chrom}_${i.SV_start}_${i.SV_end}_${i.SV_type}`
                : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

              i.key = i._id
                ? i._id
                : i.SV_start && i.SV_end
                ? `${i.chrom}_${i.SV_start}_${i.SV_end}_${i.SV_type}`
                : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

              return i
            }) ?? []
          successCallBack(
            variants,
            data?.data?.totalCount ?? 0,
            data?.data?.variantCount ?? 0
          )
        }
      } else {
        const variants =
          data?.data?.list.map((i: any) => {
            i.id = i.id
              ? i.id
              : i._id
              ? i._id
              : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

            i.key = i._id
              ? i._id
              : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

            return i
          }) ?? []
        successCallBack(
          variants,
          data?.data?.totalCount ?? 0,
          data?.data?.variantCount ?? 0
        )
      }
    },
    onError: (data) => {
      setBackop(false)
    }
  })

  const successCallBack = (
    data: any[],
    totalCount: number,
    variantsCount: number
  ) => {
    if (
      props.query &&
      props.query.title &&
      (props.query.title.includes('SNV') ||
        props.query.title === t('MT') ||
        props.query.title === 'MT' ||
        props.query.title === '线粒体' ||
        props.query.title === t('Fast track') ||
        props.query.title === 'Fast track' ||
        props.query.title === '快捷窗口' ||
        props.query.title === t('SV') ||
        props.query.title.includes('CNV') ||
        props.query.title.includes(t('STR')) ||
        props.query.key?.includes('family_') ||
        props.query.key?.includes('carrier_')) &&
      props.analysisInfo.pipelineVersion
    ) {
      //
      const variants =
        data.map((i: any) => {
          i.id = i.id
            ? i.id
            : i._id
            ? i._id
            : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

          i.key = i._id
            ? i._id
            : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

          return i
        }) ?? []

      setData(variants)

      //

      setTotalCount(totalCount ?? 0)

      setVariantCount(variantsCount ?? 0)
      const articleParams = variants
        .map((item: any) => {
          return {
            gene: item.gene,
            rsId: item.rs_id ?? item.rsid,
            pnomen: item.p_nomen ?? item.hgvsp,
            cnomen: item.c_nomen ?? item.hgvsc,
            pubmed: `${item.pubmed}`
          }
        })
        .filter((item: { rsId: any }) => item.rsId)
        .filter((item: { rsId: any }) => {
          if (rows.some((row) => row.rs_id === item.rsId)) return false
          else return true
        })

      if (
        props.query &&
        props.query.title &&
        !props.query.title.includes('CNV') &&
        !props.query.title.includes('SV') &&
        !props.query?.title?.includes('CNV Exon') &&
        !props.query?.title?.includes('Sentieon CNV')
      ) {
        const geneNames = variants
          .map((item: { gene: string }) => {
            if (item.gene && item.gene.split) return item.gene.split(';')
            else return item.gene
          })
          .filter((item: any) => item)
          .flat()
          .filter((item: any) => {
            if (rows.some((row) => row.gene === item)) return false
            else return true
          })

        if (geneNames.length) {
          if (props.query.title.includes(t('STR')))
            getOMIM.mutateAsync({
              geneNames,
              articleParams
            })

          const sampleList = props.analysisInfo.samples ?? []

          if (
            sampleList?.some(
              (sample: any) =>
                (sample.cnvBatchTaskId &&
                  sample.cnvBatchStatus === 'processed') ||
                sample.hasExomeDepthCnv
            ) &&
            type === 'sample'
          )
            fetchCnvByGene.mutateAsync(geneNames)
        }
        const conditions = variants
          .filter((item: { gene: any; pos: any }) => item.gene && item.pos)
          .map((item: { gene: any; chrom: any; pos: any }) => {
            return {
              gene: item.gene,
              chromosomePosition: `chr${item.chrom}:${item.pos}`
            }
          })
          .filter(
            (item: { gene: any; chromosomePosition: any }) =>
              item.gene && item.chromosomePosition
          )
          .filter((item: { gene: any; chromosomePosition: string }) => {
            if (
              rows.some(
                (row) =>
                  row.gene === item.gene &&
                  `chr${row.chrom}:${row.pos}` === item.chromosomePosition
              )
            )
              return false
            else return true
          })

        if (conditions && conditions.length)
          getHitoryByGeneAndChromNew.mutateAsync(conditions)
      } else if (
        props.query &&
        props.query.title &&
        (props.query.title.includes('CNV') ||
          props.query.title.includes('SV') ||
          props.query?.title?.includes('CNV Exon') ||
          props.query?.title?.includes('Sentieon CNV'))
      ) {
        const geneNames = [
          ...new Set(
            variants
              .map(
                (item: {
                  gene_info: {
                    omim_disease_genes: {
                      map: (arg0: (i: any) => string) => never[]
                    }
                    other_genes: {
                      map: (arg0: (i: any) => string) => never[]
                    }
                  }
                }) => {
                  const omim_disease_genes =
                    item.gene_info?.omim_disease_genes.map((i: any) => {
                      return `${i.symbol}`
                    }) ?? []
                  const other_genes =
                    item.gene_info?.other_genes?.map((i: any) => {
                      return `${i}`
                    }) ?? []

                  return Array.from([...new Set([...omim_disease_genes])])
                }
              )
              .flat()
              .filter((i: any) => i)
              .filter((i: string) => {
                if (
                  rows.some((row) =>
                    row.gene_info?.omim_disease_genes?.some(
                      (j: any) => i === `${j.symbol}`
                    )
                  )
                )
                  return false
                else return true
              })
          )
        ] as string[]

        if (props.analysisInfo.sampleType === 'vcf') {
          const cnvQueries: CnvDecipherInfoDto[] = variants
            .map((item: any) => {
              return {
                chr: `${item.chrom}`,
                start: `${item.SV_start || item.start}`,
                end: `${item.SV_end || item.end}`,
                genome:
                  props.analysisInfo.genomeBuild === 'hg19'
                    ? 'grch37'
                    : 'grch38'
              }
            })
            .filter((i: { chr: any }) => i.chr)
            .filter((i: { chr: any; start: any; end: any }) => {
              if (
                rows.some(
                  (row) =>
                    row.chrom === i.chr &&
                    (row.SV_start || row.start) === i.start &&
                    (row.SV_end || row.end) === i.end
                )
              )
                return false
              else return true
            })

          if (cnvQueries.length)
            fetchBatchCnvDecipherInfo.mutateAsync(cnvQueries)
        } else {
          const cnvQueries: CnvDecipherInfoDto[] = variants
            .map((item: any) => {
              return {
                chr: `${item.chrom}`,
                start: `${item.SV_start || item.start}`,
                end: `${item.SV_end || item.end}`,
                genome:
                  props.analysisInfo.genomeBuild === 'hg19'
                    ? 'grch37'
                    : 'grch38'
              }
            })
            .filter((i: { chr: any }) => i.chr)
            .filter((i: { chr: any; start: any; end: any }) => {
              if (
                rows.some(
                  (row) =>
                    row.chrom === i.chr &&
                    (row.SV_start || row.start) === i.start &&
                    (row.SV_end || row.end) === i.end
                )
              )
                return false
              else return true
            })

          if (cnvQueries.length)
            fetchBatchCnvDecipherInfo.mutateAsync(cnvQueries)
        }

        if (geneNames.length)
          getOMIM.mutateAsync({
            geneNames,
            articleParams
          })

        if (type === 'sample') getCnvManual.mutateAsync(id as unknown as number)

        const conditions = variants
          .filter((item: { gene: any; pos: any }) => item.gene && item.pos)
          .map((item: { gene: any; chrom: any; pos: any }) => {
            return {
              gene: item.gene,
              chromosomePosition: `chr${item.chrom}:${item.pos}`
            }
          })
          .filter(
            (item: { gene: any; chromosomePosition: any }) =>
              item.gene && item.chromosomePosition
          )
          .filter((item: { gene: any; chromosomePosition: string }) => {
            if (
              rows.some(
                (row) =>
                  row.gene === item.gene &&
                  `chr${row.chrom}:${row.pos}` === item.chromosomePosition
              )
            )
              return false
            else return true
          })

        if (conditions && conditions.length)
          getHitoryByGeneAndChromNew.mutateAsync(conditions)
      }

      if (props.query && props.query.key && props.query.key === '5') {
        if (variants && variants.length) {
          const mitoMapParams: GetMitoMapDataDto[] = variants
            .map((item: any) => {
              return {
                pos: item.pos,
                REF: item.REF ?? item.ref,
                ALT: item.ALT ?? item.alt
              }
            })
            .filter((item: any) => {
              if (
                rows.some(
                  (row) =>
                    row.pos === item.pos &&
                    row.REF === item.REF &&
                    row.ALT === item.ALT
                )
              )
                return false
              else return true
            })
          const articleParams = variants
            .map((item: any) => {
              return {
                gene: item.gene,
                rsId: item.rs_id ?? item.rsid,
                pnomen: item.p_nomen ?? item.hgvsp,
                cnomen: item.c_nomen ?? item.hgvsc,
                pubmed: `${item.pubmed}`,
                key: `${item.chrom}_${item.pos}_${item.REF ?? item.ref}_${
                  item.ALT ?? item.alt
                }`
              }
            })
            .filter((item: { rsId: any }) => item.rsId)
            .filter((item: { gene: any; rsId: any }) => {
              if (
                rows.some(
                  (row) => row.gene === item.gene && row.rsId === item.rsId
                )
              )
                return false
              else return true
            })

          getMitomap.mutateAsync({
            mitoMapParams,
            articleParams
          })
        }
      }

      if (
        props.query &&
        props.query.title &&
        !props.query.title.includes('CNV') &&
        !props.query.title.includes('SV') &&
        !props.query.title.includes(t('Gene')) &&
        !props.query.title.includes(t('PathWay')) &&
        !props.query.title.includes(t('STR')) &&
        !props.query?.title?.includes('CNV Exon') &&
        !props.query?.title?.includes('Sentieon CNV')
      ) {
        if (variants && variants.length) {
          const indexParams: GetManyVariantIndexDto = {
            genomeBuild: props.analysisInfo?.genomeBuild,
            variants: variants
              .map((item: any) => {
                return {
                  chrom: `${item.chrom}` as any,
                  pos: item.pos,
                  REF: item.REF ?? item.ref,
                  ALT: item.ALT ?? item.alt,
                  gene: item.gene
                }
              })
              .filter((items: { gene: any }) => {
                if (rows.some((row) => row.gene === items.gene)) return false
                else return true
              })
              .map((i: { chrom: any; pos: any; REF: any; ALT: any }) => ({
                chrom: i.chrom,
                pos: i.pos,
                REF: i.REF,
                ALT: i.ALT
              }))
          }
          const geneNames = variants
            .map((item: { gene: string }) => {
              if (item.gene && item.gene.split) return item.gene.split(';')
              else return item.gene
            })
            .filter((item: any) => item)
            .flat()
            .filter((item: any) => {
              if (rows.some((row) => row.gene === item)) return false
              else return true
            })

          const geneParams = {
            genes: geneNames as any
          }

          if (props.analysisInfo.pipelineVersion) {
            const glsIndexParam = {
              genome: props.analysisInfo?.genomeBuild,
              variant_ids: variants
                .map((item: any) => {
                  return item.variant_id
                })
                .filter((i) => i)
            }

            if (glsIndexParam.variant_ids.length) {
              getGlsIndex.mutateAsync(glsIndexParam)
            }
          } else {
            getGeneIndex.mutateAsync(geneParams)

            getIndex.mutateAsync(indexParams)
          }
          const rsIds = variants
            .map((item: any) => item.rs_id ?? item.rsid)
            .filter((item: any) => item)
            .filter((item: string) => item !== '.')
            .filter((item: any) => {
              if (rows.some((row) => row.rs_id === item)) return false
              else return true
            })
          if (rsIds.length) BatchLitVarArticle.mutateAsync(rsIds)

          // Promise.all(
          //   variants.map(async (item) => {
          //     const articleParams = {
          //       gene: item.gene,
          //       rsId: item.rs_id,
          //       pnomen: item.p_nomen,
          //       cnomen: item.c_nomen,
          //       pubmed: `${item.pubmed}`,
          //       omimPubmed: item.OMIM?.pubmedIds
          //     }

          //     return await Article.mutateAsync(articleParams)
          //   })
          // )
        }
      }
    } else {
      const variants =
        data?.map((i: any) => {
          i.id = i.id
            ? i.id
            : i._id
            ? i._id
            : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

          i.key = i._id
            ? i._id
            : `${i.chrom}_${i.pos}_${i.REF ?? i.ref}_${i.ALT ?? i.alt}`

          return i
        }) ?? []

      setData(variants)

      //

      setTotalCount(totalCount ?? 0)

      setVariantCount(variantsCount ?? 0)
      const articleParams = variants
        .map(
          (item: {
            gene: any
            rs_id: any
            p_nomen: any
            c_nomen: any
            pubmed: any
          }) => {
            return {
              gene: item.gene,
              rsId: item.rs_id,
              pnomen: item.p_nomen,
              cnomen: item.c_nomen,
              pubmed: `${item.pubmed}`
            }
          }
        )
        .filter((item: { rsId: any }) => item.rsId)
        .filter((item: { rsId: any }) => {
          if (rows.some((row) => row.rs_id === item.rsId)) return false
          else return true
        })

      if (
        props.query &&
        props.query.title &&
        !props.query.title.includes('CNV') &&
        !props.query.title.includes('SV') &&
        !props.query?.title?.includes('CNV Exon') &&
        !props.query?.title?.includes('Sentieon CNV')
      ) {
        const geneNames = variants
          .map((item: { gene: string }) => {
            if (item.gene && item.gene.split) return item.gene.split(';')
            else return item.gene
          })
          .filter((item: any) => item)
          .flat()
          .filter((item: any) => {
            if (rows.some((row) => row.gene === item)) return false
            else return true
          })

        if (geneNames.length) {
          getOMIM.mutateAsync({
            geneNames,
            articleParams
          })

          const sampleList = props.analysisInfo.samples ?? []

          if (
            sampleList?.some(
              (sample: any) =>
                (sample.cnvBatchTaskId &&
                  sample.cnvBatchStatus === 'processed') ||
                sample.hasExomeDepthCnv
            ) &&
            type === 'sample'
          )
            fetchCnvByGene.mutateAsync(geneNames)
        }
        const conditions = variants
          .filter((item: { gene: any; pos: any }) => item.gene && item.pos)
          .map((item: { gene: any; chrom: any; pos: any }) => {
            return {
              gene: item.gene,
              chromosomePosition: `chr${item.chrom}:${item.pos}`
            }
          })
          .filter(
            (item: { gene: any; chromosomePosition: any }) =>
              item.gene && item.chromosomePosition
          )
          .filter((item: { gene: any; chromosomePosition: string }) => {
            if (
              rows.some(
                (row) =>
                  row.gene === item.gene &&
                  `chr${row.chrom}:${row.pos}` === item.chromosomePosition
              )
            )
              return false
            else return true
          })

        if (conditions && conditions.length)
          getHitoryByGeneAndChromNew.mutateAsync(conditions)
      } else if (
        props.query &&
        props.query.title &&
        (props.query.title.includes('CNV') ||
          props.query.title.includes('SV') ||
          props.query?.title?.includes('CNV Exon') ||
          props.query?.title?.includes('Sentieon CNV'))
      ) {
        const geneNames = [
          ...new Set(
            variants
              .map(
                (item: {
                  gene_info: {
                    omim_disease_genes: {
                      map: (arg0: (i: any) => string) => never[]
                    }
                    other_genes: {
                      map: (arg0: (i: any) => string) => never[]
                    }
                  }
                }) => {
                  const omim_disease_genes =
                    item.gene_info?.omim_disease_genes.map((i: any) => {
                      return `${i.symbol}`
                    }) ?? []
                  const other_genes =
                    item.gene_info?.other_genes?.map((i: any) => {
                      return `${i}`
                    }) ?? []

                  return Array.from([...new Set([...omim_disease_genes])])
                }
              )
              .flat()
              .filter((i: any) => i)
              .filter((i: string) => {
                if (
                  rows.some((row) =>
                    row.gene_info?.omim_disease_genes?.some(
                      (j: any) => i === `${j.symbol}`
                    )
                  )
                )
                  return false
                else return true
              })
          )
        ] as string[]

        if (props.analysisInfo.sampleType === 'vcf') {
          const cnvQueries: CnvDecipherInfoDto[] = variants
            .map((item: any) => {
              return {
                chr: `${item.chrom}`,
                start: `${item.SV_start || item.start}`,
                end: `${item.SV_end || item.end}`,
                genome:
                  props.analysisInfo.genomeBuild === 'hg19'
                    ? 'grch37'
                    : 'grch38'
              }
            })
            .filter((i: { chr: any }) => i.chr)
            .filter((i: { chr: any; start: any; end: any }) => {
              if (
                rows.some(
                  (row) =>
                    row.chrom === i.chr &&
                    (row.SV_start || row.start) === i.start &&
                    (row.SV_end || row.end) === i.end
                )
              )
                return false
              else return true
            })

          if (cnvQueries.length)
            fetchBatchCnvDecipherInfo.mutateAsync(cnvQueries)
        } else {
          const cnvQueries: CnvDecipherInfoDto[] = variants
            .map((item: any) => {
              return {
                chr: `${item.chrom}`,
                start: `${item.SV_start || item.start}`,
                end: `${item.SV_end || item.end}`,
                genome:
                  props.analysisInfo.genomeBuild === 'hg19'
                    ? 'grch37'
                    : 'grch38'
              }
            })
            .filter((i: { chr: any }) => i.chr)
            .filter((i: { chr: any; start: any; end: any }) => {
              if (
                rows.some(
                  (row) =>
                    row.chrom === i.chr &&
                    (row.SV_start || row.start) === i.start &&
                    (row.SV_end || row.end) === i.end
                )
              )
                return false
              else return true
            })

          if (cnvQueries.length)
            fetchBatchCnvDecipherInfo.mutateAsync(cnvQueries)
        }

        if (geneNames.length)
          getOMIM.mutateAsync({
            geneNames,
            articleParams
          })

        if (type === 'sample') getCnvManual.mutateAsync(id as unknown as number)

        const conditions = variants
          .filter((item: { gene: any; pos: any }) => item.gene && item.pos)
          .map((item: { gene: any; chrom: any; pos: any }) => {
            return {
              gene: item.gene,
              chromosomePosition: `chr${item.chrom}:${item.pos}`
            }
          })
          .filter(
            (item: { gene: any; chromosomePosition: any }) =>
              item.gene && item.chromosomePosition
          )
          .filter((item: { gene: any; chromosomePosition: string }) => {
            if (
              rows.some(
                (row) =>
                  row.gene === item.gene &&
                  `chr${row.chrom}:${row.pos}` === item.chromosomePosition
              )
            )
              return false
            else return true
          })

        if (conditions && conditions.length)
          getHitoryByGeneAndChromNew.mutateAsync(conditions)
      }

      if (props.query && props.query.key && props.query.key === '5') {
        if (variants && variants.length) {
          const mitoMapParams: GetMitoMapDataDto[] = variants
            .map((item: { pos: any; REF: any; ALT: any }) => {
              return {
                pos: item.pos,
                REF: item.REF,
                ALT: item.ALT
              }
            })
            .filter((item: { pos: any; REF: any; ALT: any }) => {
              if (
                rows.some(
                  (row) =>
                    row.pos === item.pos &&
                    row.REF === item.REF &&
                    row.ALT === item.ALT
                )
              )
                return false
              else return true
            })
          const articleParams = variants
            .map(
              (item: {
                gene: any
                rs_id: any
                p_nomen: any
                c_nomen: any
                pubmed: any
                chrom: any
                pos: any
                REF: any
                ALT: any
              }) => {
                return {
                  gene: item.gene,
                  rsId: item.rs_id,
                  pnomen: item.p_nomen,
                  cnomen: item.c_nomen,
                  pubmed: `${item.pubmed}`,
                  key: `${item.chrom}_${item.pos}_${item.REF}_${item.ALT}`
                }
              }
            )
            .filter((item: { rsId: any }) => item.rsId)
            .filter((item: { gene: any; rsId: any }) => {
              if (
                rows.some(
                  (row) => row.gene === item.gene && row.rsId === item.rsId
                )
              )
                return false
              else return true
            })

          getMitomap.mutateAsync({
            mitoMapParams,
            articleParams
          })
        }
      }

      if (
        props.query &&
        props.query.title &&
        !props.query.title.includes('CNV') &&
        !props.query.title.includes('SV') &&
        !props.query.title.includes(t('Gene')) &&
        !props.query.title.includes(t('PathWay')) &&
        !props.query.title.includes(t('STR')) &&
        !props.query?.title?.includes('CNV Exon') &&
        !props.query?.title?.includes('Sentieon CNV')
      ) {
        if (variants && variants.length) {
          const indexParams: GetManyVariantIndexDto = {
            genomeBuild: props.analysisInfo?.genomeBuild,
            variants: variants
              .map(
                (item: {
                  chrom: any
                  pos: any
                  REF: any
                  ALT: any
                  gene: any
                }) => {
                  return {
                    chrom: `${item.chrom}` as any,
                    pos: item.pos,
                    REF: item.REF,
                    ALT: item.ALT,
                    gene: item.gene
                  }
                }
              )
              .filter((items: { gene: any }) => {
                if (rows.some((row) => row.gene === items.gene)) return false
                else return true
              })
              .map((i: { chrom: any; pos: any; REF: any; ALT: any }) => ({
                chrom: i.chrom,
                pos: i.pos,
                REF: i.REF,
                ALT: i.ALT
              }))
          }
          const geneNames = variants
            .map((item: { gene: string }) => {
              if (item.gene && item.gene.split) return item.gene.split(';')
              else return item.gene
            })
            .filter((item: any) => item)
            .flat()
            .filter((item: any) => {
              if (rows.some((row) => row.gene === item)) return false
              else return true
            })

          const geneParams = {
            genes: geneNames as any
          }

          if (props.analysisInfo.pipelineVersion) {
            const glsIndexParam = {
              genome: props.analysisInfo?.genomeBuild,
              variant_ids: variants
                .map((item: any) => {
                  return item.variant_id
                })
                .filter((i) => i)
            }

            if (glsIndexParam.variant_ids.length) {
              getGlsIndex.mutateAsync(glsIndexParam)
            }
          } else {
            getGeneIndex.mutateAsync(geneParams)

            getIndex.mutateAsync(indexParams)
          }
          const rsIds = variants
            .map((item: { rs_id: any }) => item.rs_id)
            .filter((item: any) => item)
            .filter((item: string) => item !== '.')
            .filter((item: any) => {
              if (rows.some((row) => row.rs_id === item)) return false
              else return true
            })
          if (rsIds.length) BatchLitVarArticle.mutateAsync(rsIds)
        }
      }
    }
  }

  const FilterModelChange = (value: any) => {
    //
    const obj: NObject = {}
    console.log('oj', value)

    Object.keys(value).map((key) => {
      const temp = value[key]

      if (temp && temp.length) {
        if (key === 'ACMG_priority') {
          // obj['acmgClassification'] = temp
          obj['acmgClassification'] = temp[0].acmgClassification

          obj['acmgScoreValue'] = temp[0].acmgScoreValue

          obj['acmgScoreOperator'] = temp[0].acmgScoreOperator
        } else if (key === 'dbSNP') {
          if (temp[0].chrom && temp[0].chrom.length)
            obj['chrom'] = temp[0].chrom

          obj['posStart'] = Number(temp[0].start)

          obj['posEnd'] = Number(temp[0].end)
        } else if (key === 'CLINVAR_variant_id') {
          obj['CLINVAR_clnsig_final'] = temp
        } else if (key === 'scip_sv_count') {
          setOverlapRate(Number(temp[0]))
        } else if (key === 'gene') {
          obj['geneNameIn'] = temp
        } else if (key === 'ccnv_priority') {
          obj['ccnv_classification'] = temp
        } else if (key === 'coding_effect') {
          obj['sequenceOntology'] = [temp].flat()
        } else if (key === 'gls_coding_effect') {
          obj['tokenToLocations'] = [temp].flat().map((i) => i.split('_')[0])
        } else if (key === 'f_score') {
          obj['fscoreOperator'] = temp[0].operator

          obj['fscoreValue'] = temp[0].value
        } else if (key === 'g_score') {
          obj['gscoreOperator'] = temp[0].operator

          obj['gscoreValue'] = temp[0].value
            ? temp[0].value / 100
            : temp[0].value
        } else if (key === 'SV_start') {
          obj['posStart'] = Number(temp[0].start)

          obj['posEnd'] = Number(temp[0].end)
        } else if (key === 'CN' || key === 'cn') {
          obj['CopyNumber'] = Number(temp[0].CopyNumber)
        } else if (key === 'sv_type') {
          obj['sv_type'] = temp
        } else if (key === 'grading') {
          obj['chrom'] = temp
        } else if (key === 'inheritance') {
          if (
            props.analysisInfo.pipelineVersion &&
            temp[0].mimNumbers &&
            temp[0].mimNumbers.length
          ) {
            obj['geneNameIn'] = temp[0].mimNumbers.map((item: any) => item.gene)
          } else
            obj['mimNumbers'] = temp[0].mimNumbers.map(
              (item: any) => item.omim_code
            )

          obj['inheritance'] =
            temp[0].inheritance && temp[0].inheritance.length
              ? temp[0].inheritance
              : null
        } else if (key === 'spliceAI_max_score') {
          obj['alphaMValue'] = Number(temp[0].alphaMValue) ?? null

          obj['alphaMOperator'] = temp[0].alphaMOperator

          obj['spliceAIValue'] = Number(temp[0].spliceAIValue) ?? null

          obj['spliceAIOperator'] = temp[0].spliceAIOperator

          obj['revelValue'] = Number(temp[0].revelValue) ?? null

          obj['revelOperator'] = temp[0].revelOperator
        } else if (key === 'coverage') {
          obj['readDepthOperator'] = temp[0].readDepthOperator

          obj['readDepthValue'] = Number(temp[0].readDepthValue) ?? null

          obj['zygosity'] = temp[0].zygosity

          obj['alleleFrequencyValue'] =
            Number(temp[0].alleleFrequencyValue) ?? null

          obj['alleleFrequencyOperator'] = temp[0].alleleFrequencyOperator

          obj['qualMin'] = Number(temp[0].qualMin) ?? null

          obj['qualMax'] = Number(temp[0].qualMax) ?? null
        } else if (key === 'index') {
          obj['ownerIndexMin'] = Number(temp[0].ownerIndexMin) ?? null

          obj['ownerIndexMax'] = Number(temp[0].ownerIndexMax) ?? null

          obj['indexMin'] = Number(temp[0].indexMin) ?? null

          obj['indexMax'] = Number(temp[0].indexMax) ?? null

          obj['organizationIndexMin'] =
            Number(temp[0].organizationIndexMin) ?? null

          obj['organizationIndexMax'] =
            Number(temp[0].organizationIndexMax) ?? null
        } else if (key === 'gnomAD_exome_ALL') {
          obj['gnomAD'] = temp[0].gnomAD

          obj['gnomADOperator'] = temp[0].gnomADOperator

          obj['gnomADValue'] = Number(temp[0].gnomADValue) ?? null
        } else if (key === 'scip_highlights_data') {
          obj['hasPositiveHighlight'] = temp[0].hasPositiveHighlight

          obj['hasNegativeHighlight'] = temp[0].hasNegativeHighlight
        } else if (key === 'scip_gnomAD&Clinvar') {
          obj['scipOverlapRateOperator'] = temp[0].scipOverlapRateOperator

          obj['scipOverlapRateValue'] =
            Number(temp[0].scipOverlapRateValue) ?? null

          obj['scipGnomAdOverlapRateOperator'] =
            temp[0].scipGnomAdOverlapRateOperator

          obj['scipGnomAdOverlapRateValue'] =
            Number(temp[0].scipGnomAdOverlapRateValue) ?? null

          obj['scipClinvarOverlapRateOperator'] =
            temp[0].scipClinvarOverlapRateOperator

          obj['scipClinvarOverlapRateValue'] =
            Number(temp[0].scipClinvarOverlapRateValue) ?? null
        } else if (key === 'scip_Geneinfo') {
          obj['scipGeneOverlapRateOperator'] =
            temp[0].scipGeneOverlapRateOperator

          obj['scipGeneOverlapRateValue'] =
            Number(temp[0].scipGeneOverlapRateValue) ?? null

          obj['scipGenePliOperator'] = temp[0].scipGenePliOperator

          obj['scipGenePliValue'] = Number(temp[0].scipGenePliValue) ?? null

          obj['scipGeneLoeufOperator'] = temp[0].scipGeneLoeufOperator

          obj['scipGeneLoeufValue'] = Number(temp[0].scipGeneLoeufValue) ?? null

          if (temp[0].scipGeneHiIn && temp[0].scipGeneHiIn.length)
            obj['scipGeneHiIn'] = temp[0].scipGeneHiIn

          if (temp[0].scipGeneTsIn && temp[0].scipGeneTsIn.length)
            obj['scipGeneTsIn'] = temp[0].scipGeneTsIn
        } else if (key === 'scip_Clingen') {
          if (temp[0].scipGeneHiIn && temp[0].scipGeneHiIn.length)
            obj['scipGeneHiIn'] = temp[0].scipGeneHiIn

          if (temp[0].scipGeneTsIn && temp[0].scipGeneTsIn.length)
            obj['scipGeneTsIn'] = temp[0].scipGeneTsIn
        } else if (key === 'rangResult') {
          setRangResultValue(temp[0])
        } else obj[key] = temp
      }
    })

    Object.keys(obj).map((key) => {
      const temp = obj[key]
      if (!temp) delete obj[key]
    })

    //

    setFilterQuery({
      ...obj
    })
  }

  const children = (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {checkList.map((items, index) => {
        return (
          <FormControlLabel
            key={`${items.index}_${index}`}
            label={items.title}
            control={
              <Checkbox
                checked={items.checked}
                onChange={(e) => handleChange2(e, items.index)}
              />
            }
          />
        )
      })}
    </Box>
  )

  const fetchCnvByGene = useMutation({
    mutationFn: async (genes: string[]) => {
      const query = {
        pageNum: 1,
        pageSize: 30,
        filter: {
          geneNameIn: genes,
          cnvType: 'exome_depth',
          classification: [
            'Likely pathogenic',
            'Pathogenic',
            'Uncertain significance'
          ]
        },
        sort: {}
      } as any

      const currentSample = props.cnvSampleId
        ? props.analysisInfo.samples?.find(
            (sample: any) => sample.id === props.cnvSampleId
          )
        : null

      const hasSCIP = props.analysisInfo.hasSCIP || currentSample?.hasSCIP

      //
      if (hasSCIP) {
        query.filter.hasScip = true
      }
      if (props.analysisInfo.pipelineVersion) {
        if (props.analysisInfo.hasExomeDepthCnv)
          return await getGlsVariants({
            parquetType: 'cnv_exomedepth',
            variants: {
              id: currentSample?.id ?? id,
              source: 'samples',
              offset: 0,
              limit: 30,
              filters: changeV1Filter(query.filter),
              sort_by: []
            }
          })
        else {
          return await getGlsVariants({
            parquetType: 'cnv_cnvkit',
            variants: {
              id: currentSample?.id ?? id,
              source: 'samples',
              offset: 0,
              limit: 30,
              filters: changeV1Filter(query.filter),
              sort_by: []
            }
          })
        }
      } else {
        return await getVariantsByCNV(query, (currentSample?.id ?? id) as any)
      }
    },
    onSuccess: (data) => {
      if (
        data &&
        data.data &&
        data.data.list &&
        Array.isArray(data.data.list) &&
        data.data.list.length
      ) {
        setCNVs(data.data.list)

        // const row = data.data.list[0]
        // setChrom(row.chrom)
        // setSVEnd(row.SV_end)
        // setSVStart(row.SV_start)
      }
    }
  })

  const fetchBatchCnvDecipherInfo = useMutation({
    mutationFn: async (cnvQueries: CnvDecipherInfoDto[]) => {
      return await getBatchCnvDecipherInfo({ cnvQueries })
    },
    onSuccess: (data) => {
      if (data && data.decipherResults && data.decipherResults.length) {
        setDecipherInfos(data.decipherResults)

        // const row = data.data.list[0]
        // setChrom(row.chrom)
        // setSVEnd(row.SV_end)
        // setSVStart(row.SV_start)
      }
    }
  })

  React.useEffect(() => {
    if (current && acmgOpen) {
      fetchGeneDiseaseSpecific.mutateAsync({
        searchValue: current.gene
      })
    }
  }, [acmgOpen, current])

  const rows = React.useMemo(() => {
    return (
      data?.map((items) => {
        const tempOMIM = OMIMs.find(
          (item) =>
            item.geneName === items.gene ||
            (items.omim_info &&
              items.omim_info.some((i: string) => i === item.geneName))
        )
        const tempCNV = CNVs.find((item) => {
          const omim_disease_genes = item?.gene_info?.omim_disease_genes.map(
            (item: any) => {
              return `${item.symbol}`
            }
          )
          const other_genes = item?.gene_info?.other_genes?.map((item: any) => {
            return `${item}`
          })
          if ([...omim_disease_genes].some((i) => i.includes(items.gene)))
            return true
          else return false
        })

        const tempCnvManual = CnvManual.find(
          (item) =>
            `${item.chrom}_${item.start}_${item.end}_${item.type}` ===
            `${items.chrom}_${items.SV_start || items.start}_${
              items.SV_end || items.end
            }_${items.SV_type || items.type}`
        )

        const tempCnvDecipherInfo = DecipherInfos.find(
          (item) =>
            `${item.chr}_${item.start}_${item.end}` ===
            `${items.chrom}_${items.SV_start || items.start}_${
              items.SV_end || items.end
            }`
        )

        const tempHistory = Historys.filter(
          (item) =>
            item.gene === items.gene &&
            item.chromosomePosition === `chr${items.chrom}:${items.pos}`
        )
        if (items.variant_type === 'SV') {
          const omim_genes = items.omim_genes ?? []
          const tempNewOMIM = omim_genes
            .map((item: string) => {
              const inheritance = newOMIM[item]
                ? newOMIM[item].inheritances
                : []
              let omim = newOMIM[item] ? newOMIM[item].omim_phenotypes_lang : []
              if (inheritance.length) {
                omim = omim.map((i: any) => {
                  i.inheritance = inheritance[0]
                  return i
                })
              }
              return omim
            })
            .filter((i: any) => i)
            .flat()

          if (tempNewOMIM.length) {
            items.newOMIMInfo = tempNewOMIM
            items.omim_phenotypes = tempNewOMIM.filter(
              (i: any) => i.clinical_synopsis
            )
            items.omim_curate_phenotypes = tempNewOMIM.filter(
              (i: any) => !i.clinical_synopsis
            )

            items.omim_genes = items.omim_genes.map((i: any) => {
              const temp = newOMIM[i] ?? {}
              const inheritance = newOMIM[i] ? newOMIM[i].inheritances : []
              let omim = newOMIM[i] ? newOMIM[i].omim_phenotypes_lang : []
              if (inheritance.length) {
                omim = omim.map((i: any) => {
                  i.inheritance = inheritance[0]
                  return i
                })
              }

              return {
                ...temp,
                omim_phenotypes: omim.filter((j: any) => j.clinical_synopsis),
                omim_curate_phenotypes: omim.filter(
                  (j: any) => !j.clinical_synopsis
                )
              }
            })
          }
        }

        if (tempHistory) {
          items.tempHistory = tempHistory
        }

        if (LitVarArticles) {
          const tempLitVarArticle = LitVarArticles.find(
            (item: any) =>
              JSON.stringify(items.rsid ?? items.rs_id) ===
              JSON.stringify(item.rsId)
          )
          if (tempLitVarArticle) items.LitVarArticles = tempLitVarArticle

          //
        }
        const start = items.SV_start || items.start
        const end = items.SV_end || items.end

        if (chromosomeData && chromosomeData.length && start && end) {
          items.Chromosomearm = chromosomeRegion(
            items.chrom,
            start,
            end,
            chromosomeData.filter((item) => item['#chrom'] == items.chrom)
          )
        }

        if (Articles) {
          const tempArticle = Articles.find(
            (item: any) =>
              JSON.stringify(items.rsid ?? items.rs_id) ===
                JSON.stringify(item.rsId) &&
              item.gene === items.gene &&
              item.pnomen === (items.p_nomen ?? items.hgvsp) &&
              item.cnomen === (items.c_nomen ?? items.hgvsc)
          )
          if (tempArticle) items.Articles = tempArticle

          //
        }

        if (items.gene && items.gene.includes(';')) {
          let OMIMArr: any[] = []
          const genes = items.gene.split(';')

          genes.map((gene: string) => {
            const tempOMIM = OMIMs.find((item) => item.geneName === gene)
            if (tempOMIM) OMIMArr.push(tempOMIM)
          })

          OMIMArr = unique(OMIMArr, 'geneName')

          items.OMIMArr = OMIMArr
        } else if (items.omim_info) {
          let OMIMArr: any[] = []
          const genes = items.omim_info.map((item: any) => item.gene_name)

          //

          genes.map((gene: string) => {
            const tempOMIM = OMIMs.find((item) => item.geneName === gene)
            if (tempOMIM) OMIMArr.push(tempOMIM)
          })

          OMIMArr = unique(OMIMArr, 'geneName')

          items.OMIMArr = OMIMArr
        } else if (items.gene_info) {
          let OMIMArr: any[] = []
          const omim_disease_genes = items.gene_info?.omim_disease_genes
            .map((item: any) => {
              return `${item.symbol}`
            })
            .join(';')
          const other_genes = items.gene_info?.other_genes
            ?.map((item: any) => {
              return `${item}`
            })
            .join(';')

          //

          Array.from([...new Set([...omim_disease_genes])]).map(
            (gene: string) => {
              const tempOMIM = OMIMs.find((item) => item.geneName === gene)
              if (tempOMIM) OMIMArr.push(tempOMIM)
            }
          )

          OMIMArr = unique(OMIMArr, 'geneName')

          items.OMIMArr = OMIMArr
        }

        if (
          props.query &&
          props.query.title &&
          props.query.title.includes(t('STR'))
        ) {
          if (props.analysisInfo.pipelineVersion) {
            items.GangSTR_repcn = items.gangstr_repcn
              ? items.gangstr_repcn.join('/')
              : ''
            items.EH_repcn = items.eh_repcn ? items.eh_repcn.join('/') : ''
            items.RU = items.repeat_unit
            items.GangSTR_repci = items.gangstr_repci
            items.GangSTR_dp = items.gangstr_dp
            items.GangSTR_q = items.gangstr_q
            items.EH_repci = items.eh_repci
            items.EH_ref = items.eh_ref
          }
          const GangSTR_repcn = items.GangSTR_repcn
          const EH_repcn = items.EH_repcn
          const GangSTR_first = GangSTR_repcn.includes('/')
            ? GangSTR_repcn.split('/')[0]
            : 0
          const GangSTR_second = GangSTR_repcn.includes('/')
            ? GangSTR_repcn.split('/')[1]
            : 0
          const EH_first = EH_repcn.includes('/') ? EH_repcn.split('/')[0] : 0
          const EH_second = EH_repcn.includes('/') ? EH_repcn.split('/')[1] : 0
          const temp = strRang.find((item) => item.gene == items.gene)
          let flag = false

          if (
            temp &&
            (GangSTR_first > temp.max ||
              GangSTR_second > temp.max ||
              EH_first > temp.max ||
              EH_second > temp.max)
          ) {
            flag = true
          }

          items.STR_Result = `${
            temp ? (flag ? t('risky') : t('risk-free')) : '-'
          }`
        }
        if (tempOMIM) items.OMIM = tempOMIM
        if (tempCNV) items.CNV = tempCNV
        if (tempCnvDecipherInfo) items.tempCnvDecipherInfo = tempCnvDecipherInfo
        if (tempCnvManual) items.tempCnvManual = tempCnvManual

        //

        const tempIndex = Indexs.find(
          (item) =>
            item.key ===
            `${items.chrom}_${items.pos}_${items.REF ?? items.ref}_${
              items.ALT ?? items.alt
            }`
        )

        const tempGeneIndex = GeneIndexs.find(
          (item) => item.gene === items.gene
        )
        const tempGlsIndex = GlsIndexs.find(
          (item) => item.variant_id === items.variant_id
        )

        if (tempGeneIndex) items.GeneIndex = tempGeneIndex
        if (tempIndex) items.Index = tempIndex
        if (tempGlsIndex) items.tempGlsIndex = tempGlsIndex

        const tempMitoMap = MitoMap.find(
          (item) =>
            item.key ===
            `${items.chrom}_${items.pos}_${items.REF ?? items.ref}_${
              items.ALT ?? items.alt
            }`
        )
        if (tempMitoMap) items.MitoMap = tempMitoMap

        return items
      }) ?? []
    )
  }, [
    data,
    OMIMs,
    Indexs,
    GlsIndexs,
    LitVarArticles,
    Articles,
    MitoMap,
    GeneIndexs,
    Historys,
    chromosomeData,
    CNVs,
    DecipherInfos,
    CnvManual,
    newOMIM
  ])

  React.useImperativeHandle(ref, () => {
    return {
      selectRowKey,
      setSelectRowKey,
      resetRowSelect,
      data,
      defaultColumns,
      totalCount
    }
  })

  const [imgAnchorEl, setimgAnchorEl] = React.useState(null)

  const handlePopoverOpen = (event: any) => {
    setimgAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setimgAnchorEl(null)
  }

  React.useEffect(() => {
    setRangResultValue('')
  }, [props.FilterSelect])

  const openImg = Boolean(imgAnchorEl)

  return (
    <div style={{ width: '100%' }}>
      <Columns2
        ref={columns2DefaultRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        indexChecked={Boolean(props.indexChecked)}
      />

      <Columns2CaseControl
        ref={columns2CaseControlRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
      />

      <Columns2CNV
        ref={columns2CNVRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
        setClingenOpen={setClingenOpen}
        setCaseNumberInfoOpen={setCaseNumberInfoOpen}
        overlapRate={overlapRate}
        key={overlapRate}
      />

      <Columns2CohortSites
        ref={columns2CohortSitesRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
        setSamplesOpen={setSamplesOpen}
        setSampleInfoOpen={setSampleInfoOpen}
        indexChecked={Boolean(props.indexChecked)}
      />

      <Columns2MT
        ref={columns2MTRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
        indexChecked={Boolean(props.indexChecked)}
      />

      <Columns2STR
        ref={columns2STRRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
      />

      <Columns2SV
        ref={columns2SVRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
      />

      <Columns2Thalassemia
        ref={columns2ThalassemiaRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
      />

      <Columns2ThalassemiaPlot
        ref={columns2ThalassemiaPlotRef}
        setCurrent={setCurrent}
        data={data}
        setColumn2={setColumnPlot2}
      />

      <Columns2Total
        ref={columns2TotalRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
        setSamplesOpen={setSamplesOpen}
      />

      <Columns1
        ref={columns1DefaultRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        indexChecked={Boolean(props.indexChecked)}
      />

      <Columns1CaseControl
        ref={columns1CaseControlRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
      />

      <Columns1CNV
        ref={columns1CNVRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
        setClingenOpen={setClingenOpen}
        setCaseNumberInfoOpen={setCaseNumberInfoOpen}
      />

      <Columns1CohortSites
        ref={columns1CohortSitesRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
        setSamplesOpen={setSamplesOpen}
        setSampleInfoOpen={setSampleInfoOpen}
        indexChecked={Boolean(props.indexChecked)}
      />

      <Columns1MT
        ref={columns1MTRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
        indexChecked={Boolean(props.indexChecked)}
      />

      <Columns1STR
        ref={columns1STRRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
      />

      <Columns1SV
        ref={columns1SVRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
      />

      <Columns1Thalassemia
        ref={columns1ThalassemiaRef}
        setCurrent={setCurrent}
      />

      <Columns1ThalassemiaPlot
        ref={columns1ThalassemiaPlotRef}
        setCurrent={setCurrent}
        data={data}
        setColumn1={setColumnPlot1}
      />

      <Columns1Total
        ref={columns1TotalRef}
        setCurrent={setCurrent}
        setOpen={setOpen}
        setHistoryOpen={setHistoryOpen}
        setCommentsOpen={setCommentsOpen}
        setTranscript_list={setTranscript_list}
        handleMenuClick={handleMenuClick}
        getColumnSearchProps={getColumnSearchProps}
        setFilterGeneOpen={setFilterGeneOpen}
        setMenuType={setMenuType}
        setFilterGeneData={setFilterGeneData}
        getFilterGene={getFilterGene}
        setIndexOpen={setIndexOpen}
        setGeneIndexOpen={setGeneIndexOpen}
        setGeneOpen={setGeneOpen}
        setAcmgOpen={setAcmgOpen}
        setOMIMOpen={setOMIMOpen}
        VariationGeneRef={ACMGRef}
        analysisInfo={analysisInfo}
        query={props.query}
        setIgvOpen={setIgvOpen}
        setIgvLocus={setIgvLocus}
        setCnvScipOpen={setCnvScipOpen}
        setCnvAllOpen={setCnvAllOpen}
        setSamplesOpen={setSamplesOpen}
      />

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backop}
        id="backdrop"
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {thalassemiaPlot &&
      props.query &&
      props.query.title &&
      (props.query.title === 'thal plot' ||
        props.query.title === '地贫 Plot') ? (
        <Box>
          <img src={thalassemiaPlot} width="100%" />
        </Box>
      ) : (
        ''
      )}

      <Stack spacing={6} width="100%">
        {defaultColumns.length ||
        columns2.length ||
        columnPlot1.length ||
        columnPlot2.length ? (
          !props.FilterSelect ? (
            <VariantsAntdTables
              rows={
                data
                  ?.sort((a, b) => {
                    // 检查a和b的type是否存在

                    const typeAExists =
                      'STR_Result' in a && a.STR_Result !== undefined

                    const typeBExists =
                      'STR_Result' in b && b.STR_Result !== undefined

                    //

                    // 如果a的STR_Result是'-' 且 b的STR_Result不是'-' 或者不存在，则a排在b后面

                    if (
                      typeAExists &&
                      a.STR_Result === '-' &&
                      (!typeBExists || b.STR_Result !== '-')
                    )
                      return 1

                    // 如果b的STR_Result是'-' 且 a的STR_Result不是'-' 或者不存在，则b排在a后面

                    if (
                      typeBExists &&
                      b.STR_Result === '-' &&
                      (!typeAExists || a.STR_Result !== '-')
                    )
                      return -1

                    // 如果a和b的STR_Result都不是'-' 或者都不存在，则保持原来的顺序

                    return 0
                  })
                  .filter((i) => {
                    if (rangResultValue && i.STR_Result) {
                      if (i.STR_Result === t(rangResultValue)) {
                        return true
                      } else if (i.STR_Result !== t(rangResultValue))
                        return false
                    } else return true
                  }) ?? []
              }
              columns={
                (columnPlot2.length &&
                props.query &&
                props.query.title &&
                (props.query.title === 'thal plot' ||
                  props.query.title === '地贫 Plot')
                  ? columnPlot2
                  : columns2) as any
              }
              rowCount={totalCount}
              variantCount={variantCount}
              isFetching={isFetching}
              setPage={fetchNextPage}
              onFilterModelChange={FilterModelChange}
              onSortModelChange={(value: any) => {
                //
                const obj: NObject = {}

                if (value.order) {
                  if (value.order.includes('ascend')) obj[value.field] = 1
                  else obj[value.field] = -1

                  //

                  setSortQuery(obj)
                } else setSortQuery({ f: -1 })
              }}
              onRowSelectionModelChange={(
                selectedRowKeys: string[],
                selectedRows: Sample[]
              ) => {
                setSelectRowKey(
                  selectedRows.map((item) => {
                    return {
                      ...item,
                      analysisItemType
                    }
                  })
                )

                props.setSelectRowKey &&
                  props.setSelectRowKey(
                    selectedRows.map((item) => {
                      return {
                        ...item,
                        analysisItemType
                      }
                    })
                  )
              }}
              isExpanded={
                !(
                  props.query &&
                  props.query.title &&
                  (props.query.title.includes(t('CNV')) ||
                    props.query.title.includes(t('Cnv')) ||
                    props.query.title.includes(t('SV')) ||
                    props.query.title.includes(t('STR')) ||
                    props.query.title === t('thalassemia') ||
                    props.query.title === 'thalassemia' ||
                    props.query.title === '地中海贫血' ||
                    props.query.title === 'thal plot' ||
                    props.query.title === '地贫 Plot' ||
                    props.query?.title?.includes('CNV Exon') ||
                    props.query?.title?.includes('Sentieon CNV'))
                )
              }
              analysisInfo={props.analysisInfo}
              isColorToggle={!props.colorToggle}
              setPagination={setPage}
              onPaginationModelChange={async (pagination: {
                page: number
                pageSize: number
              }) => {
                //
                if (pagination.page - 1 === page.pageIndex) return
                setBackop(true)
                await getVariants.mutate(pagination.page - 1)
                setPage({
                  pageSize: page.pageSize,
                  pageIndex: pagination.page - 1
                })

                // setPaginationModel({
                //   page: (pagination.current as number) - 1,
                //   pageSize: pagination.pageSize
                // })
              }}
            />
          ) : (
            <TanStackTable
              columns={
                columnPlot1.length &&
                props.query &&
                props.query.title &&
                (props.query.title === 'thal plot' ||
                  props.query.title === '地贫 Plot')
                  ? columnPlot1
                  : defaultColumns
              }
              data={
                data
                  ?.sort((a, b) => {
                    // 检查a和b的type是否存在

                    const typeAExists =
                      'STR_Result' in a && a.STR_Result !== undefined

                    const typeBExists =
                      'STR_Result' in b && b.STR_Result !== undefined

                    //

                    // 如果a的STR_Result是'-' 且 b的STR_Result不是'-' 或者不存在，则a排在b后面

                    if (
                      typeAExists &&
                      a.STR_Result === '-' &&
                      (!typeBExists || b.STR_Result !== '-')
                    )
                      return 1

                    // 如果b的STR_Result是'-' 且 a的STR_Result不是'-' 或者不存在，则b排在a后面

                    if (
                      typeBExists &&
                      b.STR_Result === '-' &&
                      (!typeAExists || a.STR_Result !== '-')
                    )
                      return -1

                    // 如果a和b的STR_Result都不是'-' 或者都不存在，则保持原来的顺序

                    return 0
                  })
                  .filter((i) => {
                    if (rangResultValue && i.STR_Result) {
                      if (i.STR_Result === t(rangResultValue)) {
                        return true
                      } else if (i.STR_Result !== t(rangResultValue))
                        return false
                    } else return true
                  }) ?? []
              }
              pagination={{
                pageIndex: 1,
                pageSize: 30
              }}
              pageCount={variantCount}
              setRowSelection={(rowSelection: number[]) => {
                if (data)
                  setSelectRowKey(
                    data
                      ?.filter((item: any, index: number) =>
                        rowSelection.some((i) => i === index)
                      )
                      .map((item) => {
                        return {
                          ...item,
                          analysisItemType
                        }
                      })
                  )

                if (data)
                  props.setSelectRowKey &&
                    props.setSelectRowKey(
                      data
                        ?.filter((item: any, index: number) =>
                          rowSelection.some((i) => i === index)
                        )
                        .map((item) => {
                          return {
                            ...item,
                            analysisItemType
                          }
                        })
                    )
              }}
              setPagination={setPage}
              setSortQuery={setSortQuery}
              sorting={[]}
              isFetching={isFetching}
              setPage={fetchNextPage}
              variantCount={variantCount}
              totalCount={totalCount}
              ref={tableRef}
              disabledExpand={Boolean(
                props.query &&
                  props.query.title &&
                  (props.query.title.includes(t('CNV')) ||
                    props.query.title.includes(t('Cnv')) ||
                    props.query.title.includes(t('SV')) ||
                    props.query.title === t('thalassemia') ||
                    props.query.title === 'thalassemia' ||
                    props.query.title === 'thal plot' ||
                    props.query.title === '地贫 Plot' ||
                    props.query?.title?.includes('CNV Exon') ||
                    props.query?.title?.includes('Sentieon CNV'))
              )}
              analysisInfo={props.analysisInfo}
              isColorToggle={!props.colorToggle}
            />
          )
        ) : (
          ''
        )}
      </Stack>

      {/* ACMG */}

      <BootstrapDialog
        onClose={() => {
          setGeneDiseaseSpecific([])

          setAcmgOpen(!acmgOpen)
        }}
        aria-labelledby="customized-dialog-title"
        open={acmgOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          <Stack direction={'row'} alignItems={'center'} spacing={4}>
            <Typography>
              ACMG{`(${t('grading')})`}
              {`(${current?.gene},${current?.c_nomen ?? current?.hgvsc},${
                current?.p_nomen ?? current?.hgvsp
              })`}
              {GeneDiseaseSpecific &&
              GeneDiseaseSpecific[0] &&
              GeneDiseaseSpecific[0].file ? (
                <Chip
                  sx={{
                    ml: 2
                  }}
                  label={t('Disease-specific genes')}
                  color="warning"
                  onClick={() => {
                    GeneDiseaseSpecific.map((item) => {
                      window.open(item.file)
                    })
                  }}
                />
              ) : (
                ''
              )}
              {current?.ClinGen_classification_data ? (
                <Chip
                  label="Clingen专家组已评估变异"
                  color="warning"
                  sx={{
                    bgcolor: '#DD6D20 !important',
                    ml: 2
                  }}
                />
              ) : (
                ''
              )}
            </Typography>

            {/* {GeneDiseaseSpecific &&
            GeneDiseaseSpecific[0] &&
            GeneDiseaseSpecific[0].file ? (
              <Button
                sx={{
                  textTransform: 'capitalize'
                }}
                onClick={() => {
                  GeneDiseaseSpecific.map((item) => {
                    window.open(item.file)
                  })
                }}
              >
                {t('Disease-specific genes')}
              </Button>
            ) : (
              ''
            )} */}
          </Stack>
        </DialogTitle>

        <Stack
          direction={'row'}
          spacing={1}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8
          }}
        >
          {/* <LoadingButton
            onClick={async () => {
              const analyzeVariantParams = {
                variantInfo: `${current?.gene},${current?.c_nomen},${current?.p_nomen},${current?.rs_id}`
              }

              if (!analyzeVariants) {
                setIsFinish(true)

                await AnalyzeVariant.mutateAsync(analyzeVariantParams)

                const acmg_chpt = document.getElementById('acmg_chpt')

                setIsFinish(false)
              } else {
                setAnalyzeVariant('')

                setIsFinish(true)

                await AnalyzeVariant.mutateAsync(analyzeVariantParams)

                setIsFinish(false)
              }
            }}
            variant="contained"
            loading={isFinish}
            endIcon={<PsychologyAltOutlined />}
            size="small"
          >
            {t('AI interpretation')}
          </LoadingButton> */}

          <IconButton
            aria-label="close"
            onClick={() => {
              setAcmgOpen(!acmgOpen)

              setAnalyzeVariant('')
            }}
            sx={{
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <CloseIcon />
          </IconButton>
        </Stack>

        <DialogContent dividers id={'acmg_chpt'}>
          <Box width={1400}>
            <ACMG
              ref={ACMGRef}
              value={current as any}
              analyzeVariants={analyzeVariants}
              setAnalyzeVariant={setAnalyzeVariant}
              setIsFinish={setIsFinish}
              analysisInfo={props.analysisInfo}
              tabsName={(props.query?.title as string) || ''}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'space-between' }}>
          {/* <Button
            onClick={handlePopoverOpen}
            aria-owns={open ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
          >
            Tavtigian classifIcation Bayes calculator
          </Button> */}

          <Stack
            direction={'row'}
            justifyContent="center"
            alignItems={'center'}
          >
            <IconButton
              onClick={() => {
                window.open(
                  'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6185798/'
                )
              }}
            >
              <OpenInNew />
            </IconButton>

            <Button
              onClick={handlePopoverOpen}
              sx={{
                textTransform: 'capitalize'
              }}
              aria-owns={open ? 'mouse-over-popover' : undefined}
              aria-haspopup="true"
            >
              {t('Reference basis')}
            </Button>

            <Button
              sx={{
                textTransform: 'capitalize'
              }}
              onClick={() => {
                window.open(
                  'https://clinicalgenome.org/working-groups/sequence-variant-interpretation/'
                )
              }}
            >
              {t('Clingen')}
            </Button>

            {/* {GeneDiseaseSpecific &&
            GeneDiseaseSpecific[0] &&
            GeneDiseaseSpecific[0].file ? (
              <Button
                sx={{
                  textTransform: 'capitalize'
                }}
                onClick={() => {
                  GeneDiseaseSpecific.map((item) => {
                    window.open(item.file)
                  })
                }}
              >
                {t('Disease-specific genes')}
              </Button>
            ) : (
              ''
            )} */}
          </Stack>

          <Popover
            id="mouse-over-popover"
            open={openImg}
            anchorEl={imgAnchorEl}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
          >
            {/* 在 Popover 中添加一个元素 */}
            <div>
              <img
                src="/images/cards/acmg.jpg"
                alt="Image 1"
                width={800}
                height={500}
              />
            </div>
          </Popover>

          <Stack direction="row" spacing={4} padding={'10px 0'}>
            <Button
              variant="outlined"
              size="small"
              autoFocus
              onClick={() => {
                setAcmgOpen(!acmgOpen)

                setAnalyzeVariant('')

                setGeneDiseaseSpecific([])
              }}
            >
              {t('close')}
            </Button>

            <Button
              variant="contained"
              size="small"
              autoFocus
              onClick={() => {
                // setAcmgOpen(!acmgOpen)
                if (props.analysisInfo.pipelineVersion) {
                  const params = {
                    chrom: String(current?.chrom) as unknown as VariantChrom,
                    pos: current?.pos as number,
                    ref: current?.REF ?? (current?.ref as string),
                    alt: current?.ALT ?? (current?.alt as string),
                    gene: current?.gene as string,
                    genome: props.analysisInfo.genomeBuild,
                    evidences: ACMGRef.current.checkedList,
                    note: ''
                  }

                  //

                  EditGlsACMGClass.mutateAsync(params)

                  ACMGRef.current.createUserACMGLogByLists &&
                    ACMGRef.current.createUserACMGLogByLists()

                  setAnalyzeVariant('')
                  return
                }
                const params: UpdateVariantACMGClassificationDto = {
                  chrom: String(current?.chrom) as unknown as VariantChrom,
                  pos: current?.pos as number,
                  REF: current?.REF ?? (current?.ref as string),
                  ALT: current?.ALT ?? (current?.alt as string),
                  gene: current?.gene as string,
                  genomeBuild: props.analysisInfo.genomeBuild,
                  evidences: ACMGRef.current.checkedList,
                  classification:
                    ACMGRef.current.description.label === 'VUS'
                      ? 'Uncertain significance'
                      : ACMGRef.current.description.label
                }

                //

                EditAcmgClass.mutateAsync(params)

                ACMGRef.current.createUserACMGLogByLists &&
                  ACMGRef.current.createUserACMGLogByLists()

                setAnalyzeVariant('')
              }}
            >
              {t('save')}
            </Button>

            <Button
              variant="contained"
              size="small"
              autoFocus
              onClick={() => {
                ACMGRef.current.reset && ACMGRef.current.reset()

                setAnalyzeVariant('')
              }}
            >
              {t('reset')}
            </Button>
          </Stack>
        </DialogActions>
      </BootstrapDialog>

      {/* 分级 */}

      <BootstrapDialog
        onClose={() => setOpen(!open)}
        aria-labelledby="customized-dialog-title"
        open={open}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {t('grading')}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => {
            setOpen(!open)
          }}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers sx={{ minWidth: 400, maxWidth: 600 }}>
          <Box width={'100%'}>
            <Grading ref={GradingRef} value={current as any} />
          </Box>
        </DialogContent>

        <DialogActions>
          <Stack direction="row" spacing={4} padding={'10px 0'}>
            <Button
              variant="outlined"
              size="small"
              autoFocus
              onClick={() => setOpen(!open)}
            >
              {t('close')}
            </Button>

            <Button
              variant="contained"
              size="small"
              autoFocus
              onClick={() => {
                // setAcmgOpen(!acmgOpen)
                if (props.analysisInfo.pipelineVersion) {
                  const params = {
                    chrom: String(current?.chrom) as unknown as VariantChrom,
                    pos: current?.pos as number,
                    ref: current?.REF ?? (current?.ref as string),
                    alt: current?.ALT ?? (current?.alt as string),
                    gene: current?.gene as string,
                    genome: props.analysisInfo.genomeBuild,
                    gls_classification: GradingRef.current.radioValue
                      ? switchACMG(GradingRef.current.radioValue)
                      : null
                  }
                  if (params.gls_classification)
                    EditGlsClass.mutateAsync(params)
                  else
                    DeleteGlsClass.mutateAsync({
                      id: current?.pair_id as string,
                      genome: props.analysisInfo.genomeBuild
                    })

                  return
                }
                const params: UpdateVariantClassificationDto = {
                  chrom: String(current?.chrom) as unknown as VariantChrom,
                  pos: current?.pos as number,
                  REF: current?.REF ?? (current?.ref as string),
                  ALT: current?.ALT ?? (current?.alt as string),
                  gene: current?.gene as string,
                  genomeBuild: props.analysisInfo.genomeBuild,
                  classification: GradingRef.current.radioValue
                    ? GradingRef.current.radioValue
                    : null
                }

                EditClass.mutateAsync(params)

                setOpen(false)
              }}
            >
              {t('classification')}
            </Button>
          </Stack>
        </DialogActions>
      </BootstrapDialog>

      {/* 基因 */}

      <BootstrapDialog
        onClose={() => setGeneOpen(!geneOpen)}
        aria-labelledby="customized-dialog-title"
        open={geneOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Variant & Gene Information:
          {`(${current?.gene},${current?.c_nomen ?? current?.hgvsc},${
            current?.p_nomen ?? current?.hgvsp
          })`}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => {
            setGeneOpen(!geneOpen)

            setAnalyzeVariant(null)
          }}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent id="scroll" dividers>
          <Box width={isWindow() ? 1400 : '100%'}>
            <VariationGene
              ref={ACMGRef}
              analyzeVariants={''}
              row={current}
              analysisInfo={props.analysisInfo}
              setAnalyzeVariant={setAnalyzeVariant}
              setIsFinish={setIsFinish}
            />
          </Box>
        </DialogContent>
      </BootstrapDialog>

      {/* 过滤基因 */}

      <BootstrapDialog
        onClose={() => {
          setFilterGeneOpen(!filterGeneOpen)

          setFilterGeneData([])
        }}
        aria-labelledby="customized-dialog-title"
        open={filterGeneOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Variant & Gene Information:
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => {
            setFilterGeneOpen(!filterGeneOpen)

            setFilterGeneData([])
          }}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent id="scroll" dividers>
          <SampleGeneTable
            defaultColumns={defaultColumns}
            filterGeneData={filterGeneData}
            tableRef={tableRef}
            analysisInfo={props.analysisInfo}
            current={current}
          />
        </DialogContent>
      </BootstrapDialog>

      {/* cnv all */}

      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={cnvAllOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          CNV Plot
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => {
            setCnvAllOpen(false)
          }}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box width={1200}>
            <CnvHG19QcPlot
              cnvRow={current}
              onlyChrom={true}
              analysisInfo={analysisInfo}
              cnvSampleId={props.cnvSampleId}
            />
          </Box>
        </DialogContent>
      </BootstrapDialog>

      {/* 评论 */}

      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={commentsOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Comments
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => {
            setCommentsOpen(!commentsOpen)
            const key = commentRef.current.key
            const comments = commentRef.current.comments

            if (key) {
              const temp = data.find(
                (items) => items.chr_pos_ref_alt_assembly === key
              )

              if (temp.user_variant_comments) {
                temp.user_variant_comments = {
                  ...temp.user_variant_comments,
                  comments
                }
              }

              temp.user_variant_comments = {
                key,
                comments
              }

              if (temp) setData(data)
            }
          }}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box width={800}>
            <Comments
              ref={commentRef}
              row={current}
              analysisInfo={props.analysisInfo}
            />
          </Box>
        </DialogContent>
      </BootstrapDialog>

      {/* 评论 */}

      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={historyOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          History
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => {
            setHistoryOpen(!historyOpen)
          }}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box width={1600}>
            <AntdTables
              columns={variantsColumn}
              rows={current?.tempHistory ?? []}
              rowCount={current?.tempHistory?.length}
              paginationModel={{
                page: 1,
                pageSize: 100
              }}
            />
          </Box>
        </DialogContent>
      </BootstrapDialog>

      {/* Clingen */}

      <BootstrapDialog
        onClose={() => setClingenOpen(!clingenOpen)}
        aria-labelledby="customized-dialog-title"
        open={clingenOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            maxWidth: '80%',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
          }}
          id="customized-dialog-title"
        >
          {`Clingen`}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setClingenOpen(!clingenOpen)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers sx={{ maxWidth: '100%' }}>
          <Box height={'100%'} width={'100%'}>
            <Clingen value={current} />
          </Box>
        </DialogContent>
      </BootstrapDialog>

      {/* OMIM */}

      <BootstrapDialog
        onClose={() => setOMIMOpen(!OMIMOpen)}
        aria-labelledby="customized-dialog-title"
        open={OMIMOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            maxWidth: '80%',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
          }}
          id="customized-dialog-title"
        >
          {`${t('Clinical Synopsis')}(Gene:${
            current?.gene
              ? current?.gene
              : current?.gene_info?.omim_disease_genes?.length
              ? current?.gene_info?.omim_disease_genes
                  .map((i: any) => {
                    return `${i.symbol}`
                  })
                  .join(';')
              : ''
          })`}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setOMIMOpen(!OMIMOpen)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers sx={{ maxWidth: '100%', minHeight: 300 }}>
          <Box height={'100%'} width={'100%'}>
            <OMIM
              params={current}
              setBackop={setBackop}
              analysisInfo={props.analysisInfo}
            />
          </Box>
        </DialogContent>
      </BootstrapDialog>

      {/* 索引 */}

      <BootstrapDialog
        onClose={() => setIndexOpen(!indexOpen)}
        aria-labelledby="customized-dialog-title"
        open={indexOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {t('Variant Index')}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setIndexOpen(!indexOpen)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box sx={{ minWidth: 800, minHeight: 200, maxWidth: 1400 }}>
            <IndexTabs
              value={current?.Index as any}
              current={current}
              analysisInfo={analysisInfo}
            />

            {/* <Index rows={current?.Index ? current?.Index.currentSamples : []} /> */}
          </Box>
        </DialogContent>
      </BootstrapDialog>

      {/* 索引 */}

      <BootstrapDialog
        onClose={() => setGeneIndexOpen(!geneIndexOpen)}
        aria-labelledby="customized-dialog-title"
        open={geneIndexOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {t('Gene Index')}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setGeneIndexOpen(!geneIndexOpen)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box sx={{ minWidth: 800, minHeight: 200, maxWidth: 1400 }}>
            <GeneIndexTabs value={current?.GeneIndex as any} />

            {/* <Index rows={current?.Index ? current?.Index.currentSamples : []} /> */}
          </Box>
        </DialogContent>
      </BootstrapDialog>

      {/* 病例数 */}

      <BootstrapDialog
        onClose={() => setCaseNumberInfoOpen(!caseNumberInfoOpen)}
        aria-labelledby="customized-dialog-title"
        open={caseNumberInfoOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {t('Details of cases')}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setCaseNumberInfoOpen(!caseNumberInfoOpen)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box sx={{ minWidth: 800, minHeight: 200, maxWidth: 1400 }}>
            <CaseNumberInfo value={current} />

            {/* <Index rows={current?.Index ? current?.Index.currentSamples : []} /> */}
          </Box>
        </DialogContent>
      </BootstrapDialog>

      {/* Cohort */}

      <BootstrapDialog
        onClose={() => setSampleInfoOpen(!sampleInfoOpen)}
        aria-labelledby="customized-dialog-title"
        open={sampleInfoOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {t('Sample Info')}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setSampleInfoOpen(!sampleInfoOpen)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box sx={{ minWidth: 800, minHeight: 200, maxWidth: 1400 }}>
            <SampleInfo
              handleClose={() => {
                setSampleInfoOpen(false)
              }}
              data={current}
              exportVariantsList={() => {
                //
              }}
              analysisInfo={analysisInfo}
            />
          </Box>
        </DialogContent>
      </BootstrapDialog>

      {/* Cohort */}

      <BootstrapDialog
        onClose={() => setSamplesOpen(!samplesOpen)}
        aria-labelledby="customized-dialog-title"
        open={samplesOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {t('Sample Info')}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setSamplesOpen(!samplesOpen)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box sx={{ minWidth: 800, minHeight: 200, maxWidth: 1400 }}>
            <SamplesTable
              samples={props.analysisInfo.samples}
              current={current}
            />
          </Box>
        </DialogContent>
      </BootstrapDialog>

      {/* IGV */}

      <BootstrapDialog
        onClose={() => setIgvOpen(!igvOpen)}
        aria-labelledby="customized-dialog-title"
        open={igvOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {t('IGV')}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => {
            const parentElement = document.getElementById('igv-div')

            // 替换（并删除）所有子节点

            parentElement &&
              parentElement.replaceChildren &&
              parentElement.replaceChildren()

            getIgv(igvLocus)

            setIgvFullOpen(!igvFullOpen)
          }}
          sx={{
            position: 'absolute',
            right: 48,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          {igvFullOpen ? <CloseFullscreenIcon /> : <OpenInFullIcon />}
        </IconButton>

        <IconButton
          aria-label="close"
          onClick={() => setIgvOpen(!igvOpen)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box
            sx={{
              minHeight: 200,
              width: igvFullOpen ? window.innerWidth - 200 : 1000
            }}
          >
            <Stack direction={'row'} spacing={4}>
              <Typography
                sx={{
                  maxWidth: 160,
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                Gene: {current?.gene}
              </Typography>

              <Typography
                sx={{
                  maxWidth: 160,
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                Pos: {current?.pos}
              </Typography>

              <Typography
                sx={{
                  maxWidth: 160,
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                HGVSc: {current?.c_nomen ?? current?.hgvsc}
              </Typography>

              <Typography
                sx={{
                  maxWidth: 160,
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >
                HGVSp: {current?.p_nomen ?? current?.hgvsp}
              </Typography>
            </Stack>

            <Box id="igv-div"></Box>
          </Box>
        </DialogContent>
      </BootstrapDialog>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={() => {
          setAnchorEl(null)
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        {menuType === 'list' ? (
          <Box width={'300px'}>
            <Stack direction={'row'} paddingLeft={4}>
              <Typography flex={1}>转录ID</Typography>

              <Typography flex={1}> 基因名</Typography>
            </Stack>

            <Divider />

            <Box maxHeight="300px" overflow="auto">
              {transcript_list.map((item, index) => {
                return (
                  <React.Fragment key={`${item.transcript_id}_${index}`}>
                    <MenuItem>
                      <Stack direction={'row'} width="100%">
                        <Typography
                          sx={{ cursor: 'pointer' }}
                          onClick={() => {
                            window.open(
                              `${ExternalLinks.ncbi.nuccore}/${item.transcript_id}`
                            )
                          }}
                          flex={1}
                          fontSize={'12px'}
                        >
                          {item.transcript_id}
                        </Typography>

                        <Typography flex={1} fontSize={'12px'}>
                          {item.gene_name}
                        </Typography>
                      </Stack>
                    </MenuItem>

                    <Divider />
                  </React.Fragment>
                )
              })}
            </Box>
          </Box>
        ) : menuType === 'clinvar_info' ? (
          <Box>{ClinvarInfoTable(current as Variation)}</Box>
        ) : menuType === 'filter' ? (
          <Box
            maxHeight="330px"
            overflow="auto"
            display={'flex'}
            flexDirection="column"
            alignItems={'center'}
            padding={'0 20px'}
          >
            <FormControl fullWidth size="small">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filterType}
                onChange={(e) => {
                  setFilterType(e.target.value)
                }}
              >
                <MenuItem value={'contain'}>{t('contain')}</MenuItem>

                <MenuItem value={'exclude'}>{t('exclude')}</MenuItem>

                <MenuItem value={'equal'}>{t('equal')}</MenuItem>
              </Select>
            </FormControl>

            <TextField
              id="outlined-number"
              InputLabelProps={{
                shrink: true
              }}
              size="small"
              value={filter}
              onChange={(e) => {
                setFilter(e.target.value)
              }}
              sx={{ marginTop: 2, marginBottom: 2 }}
              label={t('gene')}
              placeholder={`${t('Search')}${t('geneName')}`}
            />

            <Button
              onClick={() => {
                setAnchorEl(null)

                if (!filter) return setFilterQuery({})

                // 不包含
                if (filterType === 'exclude') {
                  setFilterQuery({
                    geneNameOut: [filter]
                  })
                }

                // 等于
                if (filterType === 'equal') {
                  setFilterQuery({
                    geneNameIn: [filter]
                  })
                }

                // 包含
                if (filterType === 'contain') {
                  setFilterQuery({
                    geneNameInclude: [filter]
                  })
                }

                setFilter('')
              }}
              size="small"
              variant="contained"
              fullWidth
            >
              {t('Search')}
            </Button>
          </Box>
        ) : menuType === 'filter_compare' ? (
          <Box
            maxHeight="330px"
            overflow="auto"
            display={'flex'}
            flexDirection="column"
            alignItems={'center'}
            padding={'0 20px'}
          >
            <Stack direction={'column'} spacing={2}>
              {/* <FormControl fullWidth size="small">
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={compareType}
                  onChange={(e) => {
                    setCompareType(e.target.value as 'f_score' | 'g_score')
                  }}
                >
                  <MenuItem value={'f_score'}>{'f_score'}</MenuItem>

                  <MenuItem value={'g_score'}>{'g_score'}</MenuItem>
                </Select>
              </FormControl> */}

              <FormControl fullWidth size="small">
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={compare}
                  onChange={(e) => {
                    setCompare(
                      e.target.value as 'lte' | 'gte' | 'lte.' | 'gte.'
                    )
                  }}
                >
                  <MenuItem value={'lte'}>{t('lte')}</MenuItem>

                  <MenuItem value={'gte'}>{t('gte')}</MenuItem>
                </Select>
              </FormControl>

              <TextField
                id="outlined-number"
                type="number"
                InputLabelProps={{
                  shrink: true
                }}
                size="small"
                value={compareValue}
                onChange={(e) => {
                  setCompareValue(Number(e.target.value))
                }}
                sx={{ marginTop: 2, marginBottom: 2 }}
              />

              <Button
                onClick={() => {
                  setAnchorEl(null)

                  if (compareType === 'g_score') {
                    setFilterQuery({
                      gscoreValue: compareValue,
                      gscoreOperator: compare
                    })
                  }

                  if (compareType === 'f_score') {
                    setFilterQuery({
                      fscoreValue: compareValue,
                      fscoreOperator: compare
                    })
                  }

                  setCompareValue(0)

                  // 过滤
                }}
                size="small"
                variant="contained"
              >
                {t('Search')}
              </Button>
            </Stack>
          </Box>
        ) : menuType === 'filter_gnomAD_compare' ? (
          <Box
            maxHeight="330px"
            overflow="auto"
            display={'flex'}
            flexDirection="column"
            alignItems={'center'}
            padding={'0 20px'}
          >
            <Stack direction={'column'} spacing={2}>
              <FormControl fullWidth size="small">
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={compareType}
                  onChange={(e) => {
                    setCompareType(
                      e.target.value as 'gnomAD_exome_ALL' | 'gnomAD_exome_EAS'
                    )
                  }}
                >
                  <MenuItem value={'gnomAD_exome_ALL'}>
                    {'gnomAD_exome_ALL'}
                  </MenuItem>

                  <MenuItem value={'gnomAD_exome_EAS'}>
                    {'gnomAD_exome_EAS'}
                  </MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth size="small">
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={compareGnomAD}
                  onChange={(e) => {
                    setCompareGnomAD(e.target.value)

                    if (e.target.value === '0') {
                      setFilterQuery(props.config)
                    }

                    if (e.target.value === '1') {
                      setFilterQuery({
                        maxValue: 0.001,
                        minValue: 0,
                        gtOperator: 'gte',
                        ltOperator: 'lt',
                        gnomAD: [compareType]
                      })
                    }

                    if (e.target.value === '2') {
                      setFilterQuery({
                        maxValue: 0.005,
                        minValue: 0.001,
                        gtOperator: 'gte',
                        ltOperator: 'lt',
                        gnomAD: [compareType]
                      })
                    }

                    if (e.target.value === '3') {
                      setFilterQuery({
                        maxValue: 10,
                        minValue: 0.005,
                        gtOperator: 'gte',
                        ltOperator: 'lt',
                        gnomAD: [compareType]
                      })
                    }

                    setAnchorEl(null)
                  }}
                >
                  <MenuItem value={'0'}>{'无'}</MenuItem>

                  <MenuItem value={'1'}>{'0<=s<1'}</MenuItem>

                  <MenuItem value={'2'}>{'1<=s<5'}</MenuItem>

                  <MenuItem value={'3'}>{'s>=5'}</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </Box>
        ) : menuType === 'IGV' ? (
          <Box
            maxHeight="330px"
            overflow="auto"
            display={'flex'}
            flexDirection="column"
            alignItems={'center'}
          >
            <Paper sx={{ width: 320, maxWidth: '100%' }}>
              <MenuList>
                <MenuItem
                  onClick={() => {
                    setIgvOpen(true)

                    setIgvLocus(`chr${current?.chrom}:${current?.pos}`)

                    setAnchorEl(null)
                  }}
                >
                  <ListItemText>IGV Genome Browser</ListItemText>
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    window.open(
                      `${ExternalLinks.genome}?db=${
                        analysisInfo.genomeBuild ?? 'hg19'
                      }&lastVirtModeType=default&lastVirtModeExtraState=&virtModeType=default&virtMode=0&nonVirtPosition=&position=chr${
                        current?.chrom
                      }:${current?.pos}-${current?.pos}`
                    )

                    setAnchorEl(null)
                  }}
                >
                  <ListItemText>UCSC Genome Browser</ListItemText>
                </MenuItem>
              </MenuList>
            </Paper>
          </Box>
        ) : menuType === 'scip_clingen' ? (
          <Box width={'300px'}>
            <Stack direction={'row'} paddingLeft={4}>
              <Typography flex={1}>name</Typography>

              <Typography flex={1}> halp </Typography>

              <Typography flex={1}> trip </Typography>
            </Stack>

            <Divider />

            <Box maxHeight="300px" overflow="auto">
              {current?.scip_clingen_sv_data?.map((item, index) => {
                return (
                  <Tooltip title={`chr${item.chrom}:${item.start}-${item.end}`}>
                    <React.Fragment key={`${item.transcript_id}_${index}`}>
                      <MenuItem>
                        <Stack direction={'row'} width="100%">
                          <Typography flex={1} fontSize={'12px'}>
                            {item.name}
                          </Typography>

                          <Typography flex={1} fontSize={'12px'}>
                            {item.haploinsufficiency}
                          </Typography>

                          <Typography flex={1} fontSize={'12px'}>
                            {item.triplosensitivity}
                          </Typography>
                        </Stack>
                      </MenuItem>

                      <Divider />
                    </React.Fragment>
                  </Tooltip>
                )
              })}
            </Box>
          </Box>
        ) : menuType === 'scip_gene' ? (
          <Box width={'400px'}>
            <Stack direction={'row'} paddingLeft={4}>
              <Typography flex={1}>gene</Typography>

              <Typography flex={1}> HI </Typography>

              <Typography flex={1}> TS </Typography>

              <Typography flex={1}> PLI </Typography>

              <Typography flex={1}> LOEUF </Typography>

              <Typography flex={1}> 基因覆盖情况 </Typography>
            </Stack>

            <Divider />

            <Box maxHeight="300px" overflow="auto">
              {current?.scip_gene_info_data
                ? current?.scip_gene_info_data?.map((item, index) => {
                    return (
                      <React.Fragment key={`${item.transcript_id}_${index}`}>
                        <MenuItem>
                          <Stack direction={'row'} width="100%">
                            <Typography flex={1} fontSize={'12px'}>
                              {item.name}
                            </Typography>

                            <Typography flex={1} fontSize={'12px'}>
                              {item.hi}
                            </Typography>

                            <Typography flex={1} fontSize={'12px'}>
                              {item.ts}
                            </Typography>

                            <Typography flex={1} fontSize={'12px'}>
                              {item.pli}
                            </Typography>

                            <Typography flex={1} fontSize={'12px'}>
                              {item.loeuf}
                            </Typography>

                            <Typography flex={1} fontSize={'12px'}>
                              {item.overlap_rate && item.overlap_rate === 1
                                ? t('完全覆盖')
                                : t('部分覆盖')}
                            </Typography>
                          </Stack>
                        </MenuItem>

                        <Divider />
                      </React.Fragment>
                    )
                  })
                : current?.scip_gene_info
                ? current?.scip_gene_info?.map((item: any, index: any) => {
                    return (
                      <React.Fragment key={`${item.transcript_id}_${index}`}>
                        <MenuItem>
                          <Stack direction={'row'} width="100%">
                            <Typography flex={1} fontSize={'12px'}>
                              {item.name}
                            </Typography>

                            <Typography flex={1} fontSize={'12px'}>
                              {item.hi}
                            </Typography>

                            <Typography flex={1} fontSize={'12px'}>
                              {item.ts}
                            </Typography>

                            <Typography flex={1} fontSize={'12px'}>
                              {item.pli}
                            </Typography>

                            <Typography flex={1} fontSize={'12px'}>
                              {item.loeuf}
                            </Typography>

                            <Typography flex={1} fontSize={'12px'}>
                              {item.overlap_rate && item.overlap_rate === 1
                                ? t('完全覆盖')
                                : t('部分覆盖')}
                            </Typography>
                          </Stack>
                        </MenuItem>

                        <Divider />
                      </React.Fragment>
                    )
                  })
                : ''}
            </Box>
          </Box>
        ) : (
          <Box
            maxHeight="330px"
            overflow="auto"
            display={'flex'}
            flexDirection="column"
            alignItems={'center'}
            padding={'0 20px'}
          >
            <FormControlLabel
              label="Select All"
              control={
                <Checkbox
                  checked={checkList.every((item) => item.checked)}
                  onChange={handleChange1}
                />
              }
            />

            <Divider flexItem />

            {children}

            <Button
              onClick={() => {
                setAnchorEl(null)

                if (checkList.length) {
                  const type = checkList[0].key
                  if (type === 'ACMG_classification')
                    setFilterQuery({
                      acmgClassification: checkList
                        .filter((item) => item.checked)
                        .map((items) => items.title)
                    })
                  if (type === 'classification')
                    setFilterQuery({
                      classification: checkList
                        .filter((item) => item.checked)
                        .map((items) => items.title)
                    })
                  if (type === 'CLINVAR_clnsig_final')
                    setFilterQuery({
                      CLINVAR_clnsig_final: checkList
                        .filter((item) => item.checked)
                        .map((items) => items.title)
                    })
                }
              }}
              size="small"
              variant="contained"
            >
              {t('save')}
            </Button>
          </Box>
        )}
      </Menu>

      <SwipeableDrawer
        container={isWindow() ? () => window.document.body : undefined}
        anchor={'bottom'}
        open={cnvScipOpen}
        onClose={(e) => {
          setCnvScipOpen(false)

          setCurrent(null)
        }}
        onOpen={(e) => {
          setCnvScipOpen(true)
        }}
      >
        <Box>
          {current && affected_child ? (
            <iframe
              width={'100%'}
              style={{
                minHeight: '400px'
              }}
              src={`${process.env.SCIP_URL}/?sample_id=${
                type === 'sample'
                  ? id
                  : type === 'analyze' && affected_child
                  ? affected_child.id
                  : ''
              }&assembly=${props.analysisInfo.genomeBuild}&cnv=${
                current.chrom
              }-${current.SV_start || current.start}-${
                current.SV_end || current.end
              }-${current.SV_type || current.sv_type}`}
            ></iframe>
          ) : (
            ''
          )}
        </Box>
      </SwipeableDrawer>

      <PositionedSnackbar ref={messageRef} />
    </div>
  )
})

export default VariationTables
